import { Component, ElementRef, HostListener, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { Case } from '../_types/case';
import { RelatedCasesCriteria } from '../_types/related-cases';
import { CasesService } from '../_services/cases.service';
import { CasesResumesService } from '../_services/cases-resumes.service';
import { ActivatedRoute, Router, NavigationStart } from '@angular/router';
import { TopbarService } from 'src/app/core/topbar/topbar.service';
import { filter, firstValueFrom } from 'rxjs';
import { CaseState } from '../_types/case-state';
import { Company } from '../../companies/_types/company';
import { DialogService } from 'primeng/dynamicdialog';
import { CasesDetailGeneralComponent } from './general/general.component';
import { CaseStateComponent } from './case-state/case-state.component';
import { Client } from '../../clients/_types/client';
import { Affected, AffectedPartyType, affectedPartyTypeLabel } from '../_types/affected';
import { AffectedsService } from '../_services/affecteds.service';
import { CasesDetailAffectedComponent } from './affected/affected.component';
import { CasesDetailProcessorComponent } from './processor/processor.component';
import { IParamsCollection } from 'src/app/core/jsonapi/interfaces/params-collection';
import { FilterBuilder } from 'src/app/core/jsonapi/filters-builder';
import { Filter, FilterOperation, HasFilter, NotFilter, OrFilter } from 'src/app/core/jsonapi/filter';
import { CaseNote } from '../_types/case-note';
import { CasesDetailNoteComponent } from './note/note.component';
import { CasesNotesService } from '../_services/cases-notes.service';
import { ConfirmationService, MenuItem, MessageService } from 'primeng/api';
import { CaseService } from '../_types/case-service';
import { CasesServicesService } from '../_services/cases-services.service';
import { CasesDetailServiceComponent } from './service/service.component';
import { Job } from '../_types/job';
import { JobsService } from '../_services/jobs.service';
import { FilesService } from '../../common/_services/files.service';
import { File } from '../../common/_types/file'
import { CasesFilesService } from '../_services/cases-files.service';
import { CaseFile } from '../_types/case-file';
import { CasesDetailFileComponent } from './file/file.component';
import { environment } from 'src/environment/environment';
import { CasesFilesCategoriesService } from '../_services/cases-files-categories.service';
import { CaseFileCategory } from '../_types/case-file-category';
import { ChatService } from '../../chat/_services/chat.service';
import { CaseServiceDetailComponent } from './service/case-service-detail/case-service-detail.component';
import { DatePipe } from '@angular/common';
import { Accordion, AccordionTabOpenEvent } from 'primeng/accordion';
import { ExpertsDetailComponent } from '../../experts/experts-detail/experts-detail.component';
import { CasesExpertsService } from '../_services/cases-experts.service';
import { CaseExpert } from '../_types/case-expert';
import { CaseExpertComponent } from './expert/expert.component';
import { TransactionsService } from '../../transactions/_services/transactions.service';
import { CasesUsersService } from '../_services/cases-users.service';
import { CaseUser } from '../_types/case-user';
import { CaseTechnicalComponent } from './technical/technical.component';
import { CasesLogsService } from '../_services/cases-logs.service';
import { CaseLog, CaseLogDirection, CaseLogResourceType } from '../_types/case-log';
import { ComunicationsComponent } from '../../comunications/communications/comunications.component';
import { json, RxFormBuilder, RxFormGroup } from '@rxweb/reactive-form-validators';
import { PhoneService } from '../../phone/_services/phone.service';
import { ClientPolicyComponent } from '../../clients/client-policy/client-policy.component';
import { ClientPolicy } from '../../clients/_types/client-policy';
import { TransactionsDetailComponent } from '../../transactions/transactions-detail/transactions-detail.component';
import { NotificationsService } from '../../notifications/_services/notifications.service';
import { NotesClientComponent } from './notes-client/notes-client.component';
import { CasesStatesService } from '../_services/cases-states.service';
import { MailMessageService } from '../../comunications/_services/mail-messages.service';
import moment from 'moment';
import { MailMessageRecipientService } from '../../comunications/_services/mail-messages-recipients.service';
import { OverlayPanel } from 'primeng/overlaypanel';
import { CdrService } from '../../phone/_services/cdr.service';
import { CallService } from '../../phone/_services/call.service';
import { Recording } from '../../phone/_types/recording';
import { RecordingService } from '../../phone/_services/recording.service';
import { Cdr } from '../../phone/_types/cdr';
import { MailMessage } from '../../comunications/_types/mail-message';
import { CaseLogType } from '../_types/case-log-type';
import { TemplatesService } from '../../templates/_services/templates.service';
import { PhotoReportComponent } from './photo-report/photo-report.component';
import { LocalStorageService } from 'angular-web-storage';
import { Subscription } from 'rxjs';
import { CaseIncident } from '../_types/case-incident';
import { IncidentsComponent } from './incidents/incidents.component';
import { CasesIncidentsService } from '../_services/cases-incidents.service';
import { JobsPendingInvoiceComponent } from './jobs-pending-invoice/jobs-pending-invoice.component';
import { CasesJobsComponent } from '../cases-jobs/cases-jobs.component';
import { Address } from '../../common/_types/address';
import { Tax } from '../../taxes/_types/tax';
import { TaxesService } from '../../taxes/_services/taxes.service';
import { TransactionsTypesService } from '../../transactions/_services/transactions-types.service';
import { ClientBankAccountsService } from '../../clients/_services/clients-bank-accounts.service';
import { ServicesTypesCompaniesService } from '../../services-types/_services/services-types-companies.service';
import { CasesServicesTypesService } from '../_services/cases-services-types.service';
import { IntegrationEvent } from '../../companies/_types/integration-event';
import { AuditContextService } from 'src/app/core/services/audit-context.service';
import { AuditService } from 'src/app/core/services/audit.service';
import { AuditEvents, AuditSubmodules } from 'src/app/core/_types/audit-events';
import { LoginService } from '../../login/login.service';
import { CaseLogDetailComponent } from './events/case-log-detail.component';
import { User } from '../../users/_types/user';
import { ContractZonesService } from '../../companies/_services/contracts-zones.service';
import { ZonesLinesService } from '../../zones/_services/zones-lines.service';
import { ContractCaseTypesService } from '../../companies/_services/contracts-case-types.service';
import { CaseNotificationNumber } from '../_types/case-notification-number';
import { CasesNotificationsNumbersService } from '../_services/cases-notifications-numbers.service';
import { WhatsAppChatComponent } from '../../whatsapp/chat/whatsapp-chat.component';
import { ClientsDetailComponent } from '../../clients/clients-detail/clients-detail.component';
import { GeneraliService } from '../../companies/_services/generali.service';
import { CaseStateChangeComponent } from './case-state-change/case-state-change.component';
import { RecordingDetailComponent } from '../../voip/cdr/recording/recording-detail.component';
import { CaseResumeComponent } from './case-resume/case-resume.component';
import { CaseAgentFlowSessionComponent } from './case-agent-flow-session/case-agent-flow-session.component';
import { CaseAgentFlowSessionsService } from '../_services/case-agent-flow-sessions.service';
import { CasesModesService } from '../_services/cases-modes.service';
import { Transaction } from '../../transactions/_types/transaction';
import { UsersService } from '../../users/_services/users.service';
import { CaseLogTypesService } from '../_services/cases-log-types.service';
import { ContractProcessorsService } from '../../companies/_services/contracts-processors.service';
import { CaseMediator } from '../_types/case-mediator';
import { CasesMediatorsService } from '../_services/cases-mediators.service';
import { CaseMediatorComponent } from './mediator/mediator.component';
import { Mediator } from '../../mediators/_types/mediator';
import { MediatorsDetailComponent } from '../../mediators/mediators-detail/mediators-detail.component';
import { MultiService } from '../../companies/_services/multi.service';
import { ContractOutboundPhonesService } from '../../companies/_services/contracts-outbound-phones.service';
import { ContractOutboundPhone } from '../../companies/_types/contract-outbound-phone';
import { Task } from '../../tasks/_types/task';

@Component({
    selector: 'app-cases-detail',
    templateUrl: './cases-detail.component.html',
    styleUrls: ['./cases-detail.component.scss'],
    standalone: false
})
export class CasesDetailComponent implements OnInit, OnDestroy {  

  @ViewChild('frmGenerali') frmGenerali?:ElementRef<HTMLIFrameElement>;
  private frmGeneraliEventsAttached: boolean = false;

   @ViewChild('accordionDetailsTab', { static: false })
  accordionDetailsTab!: Accordion;

  @ViewChild('accordionTabs', { static: false })
  accordionTabs!: Accordion;

  @ViewChild(CasesJobsComponent, { static: false })
  casesJobsComponent!: CasesJobsComponent;

  @ViewChild('op', { static: false })
  op?: OverlayPanel;
  public opFile?: CaseFile;
  
    public hoveredImage: CaseFile | null = null;

  public today: Date = new Date();
  private routerSubscription!: Subscription;
  public caseFormGroup!: RxFormGroup;
  public case: Case = new Case();
  public hasCaseResume: boolean = false;
  //el expediente tiene al menos un informe pericial generado por el agente de IA
  public hasCaseAgentInforme: boolean = false;
  public originalCaseState?:CaseState;
  public caseNotificationNumbers: CaseNotificationNumber[] = [];
  public caseNotificationNumber: CaseNotificationNumber  = new CaseNotificationNumber();
  public companies: Company[] = [];
  public caseStates: CaseState[] = [];
  public cancelReasonDescription: String | null = null;
  public totalAffecteds: Affected[] = [];

  /** Etiqueta del tipo de implicado (afectado, causante o cliente), para pintarla en la vista. */
  public affectedPartyTypeLabel(partyType: AffectedPartyType): string {
    return affectedPartyTypeLabel(partyType);
  }
  public caseExperts: CaseExpert[] = [];
  public caseExpertsHeader: CaseExpert[] = [];
  public caseMediatorsHeader: CaseMediator[] = [];
  public caseTechnicals: CaseUser[] = [];
  public caseNotes: CaseNote[] = [];
  public caseJobs: Job[] = [];
  public caseFiles: any[] = [];
  public caseServices: CaseService[] = [];
  public caseJobsWorkers: any[] = [];
  public caseFilesServices: any[] = [];
  public caseFileCategories: CaseFileCategory[] = [];
  public caseFilesWithoutService: any[] = [];
  //adjuntos de "Generales" agrupados: una fila por sesión de videoperitación (+ un grupo sin sesión para el resto)
  public caseFilesGeneralGroups: { key: string; label: string | null; files: any[] }[] = [];
  //sesiones de videoperitación del expediente, para cruzar sus adjuntos (fotos por session.Id, PDFs por SessionId)
  private agentSessions: any[] = [];
  private agentSessionsLoaded = false;
  //adjuntos que ha mandado el asegurado (por ahora, fotos recibidas por WhatsApp): van en su propia
  //carpeta para no mezclarlos con los generales del expediente
  public caseFilesInsured: any[] = [];
  public caseFileCategoryFilter: string = "all";
  public caseTransactionsBudget: any = [];
  public caseTransactionsBudgetResume: number = 0;
  public caseTransactionsBudgetResumePercent: number = 0;
  public caseTransactionsPurchase: any = [];
  public caseTransactionsWorkerInvoice: any = [];
  public caseLogs: any = [];  
  public relatedCasesCount: number = 0;
  public relatedCasesIds: string[] = [];
  public relatedCasesCriteria: RelatedCasesCriteria = RelatedCasesCriteria.Policy;
  public caseNotesClient: CaseNote[] = [];
  public loadingNotes: boolean = false;
  public lastGridCaseNotesClient: any;
  public lastGridCaseNotes: any;
  public totalNotesRecords: number = 0;
  public totalNotesClientRecords: number = 0;
  public loadingServices: boolean = false;
  public totalServicesRecords: number = 0;
  public loadingAffecteds: boolean = false;
  public totalAffectedsRecords: number = 0;
  public loadingExperts: boolean = false;
  public totalExpertsRecords: number = 0;
  public loadingTechnicals: boolean = false;
  public totalTechnicalsRecords: number = 0;
  public loadingTransactions: boolean = false;
  public loadingTransactionsBudget: boolean = false;
  public totalTransactionsBudgetRecords: number = 0;
  public loadingTransactionsPurchase: boolean = false;
  public totalTransactionsPurchaseRecords: number = 0;
  public loadingLogs: boolean = false;
  public totalLogsRecords: number = 0;
  public allowWrite: boolean = false;
  public allowDelete: boolean = false;
  public allowAccessCaseServices: boolean = false;
  public fileActions: any;
  public displayModal: boolean = false;  
  public optionsSidebarVisible: boolean = false;
  public revisionDate: Date= new Date(); 
  public jobs: any = [];
  public loadingCaseIncident: boolean = false;
  public totalCaseIncidentsRecords: number = 0;
  public caseIncidents: CaseIncident[] = [];  
  public totalCompensationTransactionsRecords: number = 0;
  public compensationTransactions: any = [];
  public loadingCompensationTransactions: boolean = false;
  public displayCompensationModal: boolean = false;
  public compensation: any = {};
  public taxes: Tax[] = [];
  public loadingTaxes: boolean = false;
  public loadingClientBankAccounts: boolean = false;
  public clientBankAccounts: any = [];
  public filters: any = {    
    source: new Filter(FilterOperation.equals, 'source')
  };
  public caseLogsFilter: any = {
    caseId: new Filter(FilterOperation.equals, 'caseId'),
    caseLogTypeId: new Filter(FilterOperation.equals, 'caseLogTypeId'),
    direction: new Filter(FilterOperation.equals, 'direction'),
    resourceType: new Filter(FilterOperation.equals, 'resourceType'),
    completedAt: new Filter(FilterOperation.equals, 'completedAt'),
    message: new Filter(FilterOperation.contains, 'message'),
    caseNotificationNumberId: new Filter(FilterOperation.equals, 'caseNotificationNumberId')
  };
  public notifications: any;
  public showNotifications: boolean = false;
  public pendingLogs:boolean = false;
  public hasPendingLogs:boolean = false;
  public showPendingLogsModal:boolean = false;
  public changeStates:boolean = false;
  public distanceToCityCenter?:number = 0;
  public finalStates: any = [];
  public resourceCaseLog: { [key: string]: any } = [];
  public lastGridLogEvent: any;  
  public lastGridCaseTechnicals: any;
  public lastGridCaseIncident: any;


  public caseLogTypes: CaseLogType[] = [];
  public caselogDirections: any[] = [{name: 'Entrada', id: CaseLogDirection.In},{name: 'Salida', id: CaseLogDirection.Out}];
  public caseLogResourceType: any[] = [
    {name: 'Llamada', id: CaseLogResourceType.Call},
    {name: 'Correo', id: CaseLogResourceType.Mail},
    {name: 'Chat', id: CaseLogResourceType.Chat},
    {name: 'SMS', id: CaseLogResourceType.SMS},
  ];
  public casesJobsVisible = true;  
  //panel de opciones de telefono
  @ViewChild('phoneOverlayPanel') public phoneOverlayPanel?:OverlayPanel;
  public phoneOverlayPanelData:any = {
    phoneNumber: null,
    callerId: null
  };
  //public attachmentsToSend : MailMessageAttachment[] = [];
  public filesIdsToSend: string[] = []; //Si se quiere adjuntar archivos a la comunicación
  public displayEvent: boolean = false;
  public imagesUrl: string = environment.api_gw + 'common/files/';  
  public servicesTypes: any[] = [];
  public selectedServiceTypes: any[] = [];
  public processors: any[] = [];
  public showDeclarationModal: boolean = false;  
  public allowAssignProcessor: boolean = false;
  public allowRecordingAccess: boolean = false;
  private presenceTimeout: any = null;
  public otherUserConnected?: User | null = null;
  public postalCodeNotInZonesFromCompany: boolean = false;
  public caseStateConfiguration:any = {};
  public caseStateMetadata:any = {};
  public AIGeneratedJobs: number = 0;
  public AIGeneratedJobsMessage: string = "";
  public messageGuarantee: string = "";

  public countCaseFiles: number = 0;
  public countAffecteds: number = 0;
  public countExperts: number = 0;
  public countTechnicals: number = 0;
  public countNotes: number = 0;
  public countTransactionsPurchase: number = 0;
  public countIncidents: number = 0;
  public countNotesClient: number = 0;
  public countCompensationTransactions: number = 0;
  public countLogs: number = 0;
  public displayCaseNotificationNumberModal: boolean = false;
  private caseModeCode: string | null = null;
  //Base imponible a partir de la cual un presupuesto convierte el expediente en siniestro grave.
  private readonly SERIOUS_SINISTER_BUDGET_THRESHOLD = 10000;
  public currentUser: User | null = null;

  public countMediators: number = 0;
  public caseMediators: CaseMediator[] = [];
  public loadingMediators: boolean = false;
  public totalMediatorsRecords: number = 0;
  public lastGridCaseMediators: any;
  public contractOutboundPhones: ContractOutboundPhone[] = [];
  constructor(
    private casesService: CasesService,
    private route: ActivatedRoute,
    private router: Router,
    private topbarService: TopbarService,
    private dialogService: DialogService,
    private affectedsService: AffectedsService,
    private casesExpertsService: CasesExpertsService,
    private usersService: UsersService,
    private caseUsersService: CasesUsersService,
    private casesNotesService: CasesNotesService,
    private casesLogsService: CasesLogsService,
    private jobsService: JobsService,
    private casesServicesService: CasesServicesService,
    private confirmationService: ConfirmationService,
    private messageService: MessageService,
    private filesService: FilesService,
    private casesFilesService: CasesFilesService,
    private chatService: ChatService,
    private caseFileCategoriesService: CasesFilesCategoriesService,
    private transactionsService: TransactionsService,
    private phoneService: PhoneService,
    private formBuilder: RxFormBuilder,
    private notificationsService: NotificationsService,
    private casesStatesService: CasesStatesService,
    private mailMessageService: MailMessageService,
    private mailMessageRecipientService: MailMessageRecipientService,
    private cdrService:CdrService,
    private callService:CallService,
    private recordingService:RecordingService,
    private templateService: TemplatesService,
    private storage: LocalStorageService,
    private servicesTypesCompanyService: ServicesTypesCompaniesService,
    private caseServiceTypesService: CasesServicesTypesService,
    private caseIncidentsService: CasesIncidentsService,
    private taxesService: TaxesService,
    private transactionsTypesService: TransactionsTypesService,
    private clientBankAccountsService: ClientBankAccountsService,
    public loginService: LoginService,
    private contractZonesService: ContractZonesService,
    private zonesLinesService: ZonesLinesService,
    private contractCaseTypesService: ContractCaseTypesService,
    private caseNotificationsNumbersService: CasesNotificationsNumbersService,
    private generaliService: GeneraliService,
    private caseModeService: CasesModesService,
    private caseLogTypeService: CaseLogTypesService,
    private contractProcessorsService: ContractProcessorsService,
    private casesMediatorsService: CasesMediatorsService,
    private casesResumesService: CasesResumesService,
    private multiService: MultiService,
    private contractOutboundPhonesService: ContractOutboundPhonesService,
    private auditContextService: AuditContextService,
    private auditService: AuditService,
    private caseAgentFlowSessionsService: CaseAgentFlowSessionsService
  ) {
    this.router.routeReuseStrategy.shouldReuseRoute = () => false;
    this.caseFormGroup = this.formBuilder.formGroup<Case>(this.case) as RxFormGroup;    
  }

  canDeactivate():boolean{
    let ret = true;
    let message = "";
    this.loadPendingLogs(this.case.id!, false);
    if(this.hasPendingLogs) message = (message!=""?"\n":"") + " - Tienes comunicaciones pendientes de revisión.";
    if(this.case?.revisionDate==null) message = (message!=""?"\n":"") + " - El expediente no tiene fecha de revisión.";
    if(message!=""){
      ret = confirm("Atención, se han encontrado problemas:\n"+ message +"\n\n¿quieres salir de igualmente?")
    }
    return ret;
  }

  //cap. 1 · Observaciones: cuando se acumulan ≥2 avisos "PERITO GUAI ... no coincide" se colapsan.
  showAllLocationMismatches = false;

  //separa las Observaciones (Case.Notes) en el texto libre y los avisos "PERITO GUAI ... no coincide",
  //para mostrar solo el más reciente y colapsar el resto cuando hay ≥2. Oculta el marcador [ref:...].
  parseObservaciones(notes: string | null | undefined): { other: string; mismatches: string[] } {
    if (!notes) return { other: '', mismatches: [] };
    const chunks = notes.split(/\n\s*\n/);
    const mismatches: string[] = [];
    const other: string[] = [];
    for (const c of chunks) {
      const t = c.trim();
      if (!t) continue;
      if (/^PERITO GUAI\b.*no coincide/i.test(t)) {
        mismatches.push(t.replace(/\n?\[ref:[^\]]*\]\s*$/i, '').trim());
      } else {
        other.push(t);
      }
    }
    return { other: other.join('\n\n'), mismatches };
  }

  //La banda de expedientes relacionados lleva al expediente en cuestión cuando solo hay uno, y al
  //listado filtrado cuando hay varios. El filtro del listado depende del criterio con el que se
  //encontraron: por póliza, o por asegurado + dirección del expediente.
  public get relatedCasesLink(): string {
    if (this.relatedCasesCount == 1 && this.relatedCasesIds.length == 1) {
      return 'cases/' + this.relatedCasesIds[0];
    }
    if (this.relatedCasesCriteria == RelatedCasesCriteria.ClientAddress) {
      return 'cases?clientName=' + encodeURIComponent(this.case.client?.name ?? '')
             + '&caseAddress=' + encodeURIComponent(this.case.address?.addressLine1 ?? '');
    }
    return 'cases?clientPolicy=' + encodeURIComponent(this.case.clientPolicy?.policyNumber ?? '');
  }

  public get relatedCasesMessage(): string {
    if (this.relatedCasesCriteria == RelatedCasesCriteria.ClientAddress) {
      return 'Existen otros expedientes registrados para el mismo asegurado y dirección.';
    }
    return 'Existen otros expedientes registrados para el número de poliza ' + (this.case.clientPolicy?.policyNumber ?? '') + '.';
  }

  async ngOnInit() {
    document.addEventListener('scroll', this.onContentScroll, true);

    this.currentUser = this.storage.get('user') as User;
    this.topbarService.setWindowTitle("Detalles de expediente");
    this.topbarService.setTitle("Detalles de expediente");
    this.topbarService.addBreadcrumb("Expedientes", "/cases");    

    this.route.params.subscribe(async params => {
      let id = params['id'];
      if (id != null && id != '0') {
        //Buscamos notificaciones
        this.loadNotifications(id);
        this.loadPendingLogs(id, true);
        await this.loadCase(id);

        //apertura de la ficha por parte del usuario. Va aquí y no en loadCase porque loadCase se llama
        //desde muchos sitios para refrescar los datos, y eso no es abrir el expediente otra vez.
        this.auditService.track(AuditEvents.CASE_ACCESS, {
          caseId: id,
          entityType: 'case',
          entityId: id,
          information: 'Acceso a expediente ' + (this.case?.caseNumber ?? '')
        });

        this.loadJobs();
        this.updatePresence();
        
        this.loadCaseStates(); //lo he cambiado aqui para que traiga el caseStateId actual por si esta en estado final.
        this.loadCaseNotificationsNumbers();
        this.loadServices();
        this.loadServicesTypes();
        this.loadTransactionsPurchase();
        this.loadTransactionsWorkerInvoice();
        this.loadAffecteds(); //Porque la información ahora se muestra en la cabecera.
        this.loadCaseExperts();//Porque la información ahora se muestra en la cabecera.
        this.loadCaseLogTypes(); //Filtro de categorias en Eventos.
        this.loadCaseMediators();//Porque la información se muestra en la cabecera.
        this.loadContractOutboundPhones(); //teléfonos salientes del contrato
        this.counterInfo(); //Resumen de las cabeceras
        this.validateSeriousSinisterCaseHasTechnicals();
        
        this.loadProcessors();

      }else{
        this.loadCaseStates();
        this.loadProcessors();
      }
    });    

    if (this.case.address == null) this.case.address = new Address();

    this.allowWrite = this.loginService.hasPermission("CASES.WRITE");
    this.allowDelete = this.loginService.hasPermission("CASES.DELETE");
    this.allowAccessCaseServices = this.loginService.hasPermission("CASES_SERVICES.ACCESS");
    this.allowAssignProcessor =  this.loginService.hasPermission("CASES.ASSIGN_PROCESSOR");
    this.allowRecordingAccess = this.loginService.hasPermission("CASES.ACCESS_RECORDINGS");

   /* this.fileActions = (file: any) => [
      {
        label: 'Opciones',
        items: [
          {
            label: 'Descargar',
            icon: 'pi pi-download',
            command: () => this.downloadFile(file.fileId)
          },
          {
            label: 'Editar',
            icon: 'pi pi-pencil',
            command: (event: any) =>{ 
              this.editCaseFile(file);
            }
          },
          {
            label: 'Eliminar',
            icon: 'pi pi-trash',
            command: () => this.deleteCaseFile(file)
          }
        ]
      }
    ];*/
    this.loadCaseFileCategories();
  }

  async opShow($event:any, file?:CaseFile){
    this.opFile = file;
    if(this.op) this.op.show($event)
  }

  async loadProcessors(){
      let params: IParamsCollection = {
        sort: ['name'],
        page: { number: 1, size: 1000 }
      };
  
      // filtrar solo tramitadores
      let filters: any = {
        userType: new OrFilter([
          new Filter(FilterOperation.equals, 'userType.code', '', 'processor'),
          new Filter(FilterOperation.equals, 'id', '', this.currentUser?.id)
        ]),
        id: new Filter(FilterOperation.any, 'id', '')
      };
    

      //lista de tramitadores. Irán filtrados por su permiso
      if(this.loginService.hasPermission('CASES.VIEW_ALL_CASES')){
        //creamos filtros
        params.filter = FilterBuilder.fromObject(filters).build();  
        let response = await firstValueFrom(this.usersService.all(params));
        this.processors = response.data;
      }else{
        //obtienes los contratos donde el usuario es tramitador.
        let filters2 = {
          processorId: new Filter(FilterOperation.equals, 'processorId', "", this.currentUser?.id)
        };  
        let params2: IParamsCollection = { page: { number: 1, size: 2000}}
        //creamos filtros
        params2.filter = FilterBuilder.fromObject(filters2).build();
        var contractProcessors = await firstValueFrom(this.contractProcessorsService.all(params2)).then(response => response.data);
        var contractsIds = contractProcessors.filter((v, i, a) => a.findIndex(t => (t.contractId === v.contractId)) === i).map(cp => cp.contractId);
  
        //los tramitadores de los mismos contratos que el usuario
        let filtersCases = {
          contractId: new Filter(FilterOperation.any, 'contractId', "", contractsIds)        
        };  
        let paramsCases: IParamsCollection = { page: { number: 1, size: 2000}}
        //creamos filtros
        paramsCases.filter = FilterBuilder.fromObject(filtersCases).build();
        var contractProcessorsAll = await firstValueFrom(this.contractProcessorsService.all(paramsCases)).then(response => response.data);
        var contractProcessorsAllIds = contractProcessorsAll.filter((v, i, a) => a.findIndex(t => (t.processorId === v.processorId)) === i).map(cp => cp.processorId);       
  
        //añadimos a el mismo
        contractProcessorsAllIds.push(this.currentUser?.id!);
        if(this.case && this.case.processorId)  contractProcessorsAllIds.push(this.case.processorId);

        //filtramos por los usuarios que forman parte de los mismos contratos que el usuario logueado.
        filters.id = new Filter(FilterOperation.any, 'id', '', contractProcessorsAllIds);
        params.filter = FilterBuilder.fromObject(filters).build();  
        let response = await firstValueFrom(this.usersService.all(params));
        this.processors = response.data;
  
      }
    }
/*
  async loadProcessors(){
    let filter = {
      userTypeProcessor: new Filter(FilterOperation.equals, 'userType.code', '', 'PROCESSOR')
    };
    let params: IParamsCollection = {
      sort: ['name'],
      page: { size: 500 },
      filter: FilterBuilder.fromObject(filter).build(),
      fields: {
        users: 'name'
      }
    };
    let response = await firstValueFrom(this.userService.all(params));
    this.processors = response.data;
  }*/

  async loadCaseNotificationsNumbers() {
    let filter : any = {
      caseId: new Filter(FilterOperation.equals, "caseId", '', this.case.id)
    };
    let params:IParamsCollection = {
      page: { size: 50 },
      sort: ['date'],
      filter: FilterBuilder.fromObject(filter).build()
    };
    let response = await firstValueFrom(this.caseNotificationsNumbersService.all(params));
    this.caseNotificationNumbers = response.data;
  }

   async loadCaseLogTypes() {
    let filter : any = {
      //caseId: new Filter(FilterOperation.equals, "caseId", '', this.case.id)
    };
    let params:IParamsCollection = {
      page: { size: 50 },
      sort: ['name'],
      filter: FilterBuilder.fromObject(filter).build()
    };
    let response = await firstValueFrom(this.caseLogTypeService.all(params));
    this.caseLogTypes = response.data;
  }

  async counterInfo(){
    //adjuntos:
    let params: IParamsCollection = {
      page: { size: 1 },
    }    
    let filters: any = {
      caseId: new Filter(FilterOperation.equals, "caseId")
    };
    filters.caseId.value = this.case.id;
    params.filter = FilterBuilder.fromObject(filters).build();

    //Notas
    let paramsNotes: IParamsCollection = { 
      page:{size: 1}
    };
    let filtersNotes: any = {
      caseId: new Filter(FilterOperation.equals, "caseId", '', this.case.id),
      caseNoteType: new Filter(FilterOperation.equals, "caseNoteType", '', "0"),
    };
    paramsNotes.filter = FilterBuilder.fromObject(filtersNotes).build();

    //solicitudes de compra
    let paramsPurchase: IParamsCollection = { page:{size: 1 }}
    let filtersPurchase: any = {
      caseId: new Filter(FilterOperation.equals, "caseId", '',this.case.id),
      transactionTypeCode: new Filter(FilterOperation.equals, "transactionType.code", '', "purchase_order")
    };
    paramsPurchase.filter = FilterBuilder.fromObject(filtersPurchase).build();

    //consultas/reclamaciones
    let paramsNotesClients: IParamsCollection = { page:{size: 1}}
    let filtersNotesC: any = {
      caseId: new Filter(FilterOperation.equals, "caseId",'', this.case.id),
      caseNoteType: new NotFilter(FilterOperation.equals, "caseNoteType", '', "0"),
    };
    paramsNotesClients.filter = FilterBuilder.fromObject(filtersNotesC).build();

    //devoluciones
    let paramsCompensationTransactions: IParamsCollection = { page:{size: 1}};
    let filtersCompensationTransactions: any = {
      caseId: new Filter(FilterOperation.equals, "caseId",'', this.case.id),
      transactionTypeCode: new Filter(FilterOperation.any, "transactionType.code", '', "client_compensation")
    };
    paramsCompensationTransactions.filter = FilterBuilder.fromObject(filtersCompensationTransactions).build();    

    let [
      response,                        //adjuntos
      response2,                       //afectados
      response3,                       //peritos
      response4,                       //técnicos
      response5,                       //mediadores
      responseNotes,                   //notas
      responsePurchase,                //solicitudes de compra
      responseIncidents,               //incidencias
      responseNotesC,                  //consultas/reclamaciones
      responseCompensationTransactions,//devoluciones
      responseLogs                     //logs
    ] = await Promise.allSettled([
      firstValueFrom(this.casesFilesService.all(params)),
      firstValueFrom(this.affectedsService.all(params)),
      firstValueFrom(this.casesExpertsService.all(params)),
      firstValueFrom(this.caseUsersService.all(params)),
      firstValueFrom(this.casesMediatorsService.all(params)),
      firstValueFrom(this.casesNotesService.all(paramsNotes)),
      firstValueFrom(this.transactionsService.all(paramsPurchase)),
      firstValueFrom(this.caseIncidentsService.all(params)),
      firstValueFrom(this.casesNotesService.all(paramsNotesClients)),
      firstValueFrom(this.transactionsService.all(paramsCompensationTransactions)),
      firstValueFrom(this.casesLogsService.all(params))
    ]);

    const total = (result: PromiseSettledResult<any>) => result.status === 'fulfilled' ? result.value.meta['total'] : 0;

    this.countCaseFiles = total(response);
    this.countAffecteds = total(response2);
    this.countExperts = total(response3);
    this.countTechnicals = total(response4);
    this.countMediators = total(response5);
    this.countNotes = total(responseNotes);
    this.countTransactionsPurchase = total(responsePurchase);
    this.countIncidents = total(responseIncidents);
    this.countNotesClient = total(responseNotesC);
    this.countCompensationTransactions = total(responseCompensationTransactions);
    this.countLogs = total(responseLogs);

    if(this.countCompensationTransactions>0) this.loadCompensationTransactions(); //porque mostramos el total en la cabecera de los trabajos.
  }

  async validateSeriousSinisterCaseHasTechnicals(message: string = "Caso de siniestro grave, es necesario asignar al menos un tecnico al expediente."){

    if(this.case.id == null) return;

    const caseModeCode = this.caseModeCode ?? await this.loadCaseModes();
    this.caseModeCode = caseModeCode;

    if(caseModeCode !== "SERIOUS_SINISTER") return;

    let params: IParamsCollection = {
      page: { size: 1 }
    };
    let filters: any = {
      caseId: new Filter(FilterOperation.equals, "caseId", "", this.case.id)
    };
    params.filter = FilterBuilder.fromObject(filters).build();
    let response = await firstValueFrom(this.caseUsersService.all(params));
    this.countTechnicals = response.meta['total'];

    if(this.countTechnicals == 0){
      this.editCaseTechnical(message);
    }
  }

  //Si algún presupuesto del expediente alcanza o supera el umbral de base imponible se exige
  //asignar un técnico. La comprobación se hace siempre: aunque el expediente ya sea siniestro
  //grave (p.ej. puesto a mano) hay que seguir obligando a que haya técnico. Se evalúa sobre los
  //presupuestos ya persistidos (this.caseTransactionsBudget) y no sobre lo que devuelve el
  //diálogo al cerrar: las líneas se guardan al añadirlas, así que cuenta aunque cierren el
  //presupuesto sin volver a guardarlo. Cuenta cualquier presupuesto, esté en el estado que esté.
  async promoteToSeriousSinisterIfBudgetThresholdReached(){
    let reachesThreshold = this.caseTransactionsBudget.some((t: any) =>
      parseFloat(t.subtotal ?? 0) >= this.SERIOUS_SINISTER_BUDGET_THRESHOLD
    );
    if(!reachesThreshold) return;

    //Si todavía no es siniestro grave, lo pasamos a ese modo.
    if(this.caseModeCode != "SERIOUS_SINISTER"){
      this.caseModeCode = "SERIOUS_SINISTER";
      //buscamos el id del modo de expediente de siniestro grave
      let caseModeRelationParams: IParamsCollection = {
        page: { number: 1, size: 10 },
        filter: FilterBuilder.fromObject({ code: new Filter(FilterOperation.equals, 'code', '', "SERIOUS_SINISTER") }).build()
      };
      let relationsResponse = await firstValueFrom(this.caseModeService.all(caseModeRelationParams));

      this.case.caseModeId = relationsResponse?.data && relationsResponse?.data[0] && relationsResponse?.data[0].id ? relationsResponse?.data[0]?.id : '';
      await firstValueFrom(this.casesService.save(this.case));
      this.messageService.add({ closable: true, severity: 'success', detail: "Expediente cambiado a tipo siniestro grave" });
    }

    //Obligamos a asignar técnico tanto si lo acabamos de cambiar como si ya era siniestro grave.
    await this.validateSeriousSinisterCaseHasTechnicals();
  }



  async loadContractZones(contratId: any) {

    let filters = {
      companyId: new Filter(FilterOperation.equals, 'contractId', "", contratId)
    };

    let params: IParamsCollection = {
      page: { size: 0 },
      filter: FilterBuilder.fromObject(filters).build()
    };

    let response = await firstValueFrom(this.contractZonesService.all(params));
    var listZonesIds = response.data.map(m => m.zoneId);
    
    let filters2 = {
      zoneId: new Filter(FilterOperation.any, 'zoneId', '', listZonesIds),
      value: new Filter(FilterOperation.equals, 'value', '', this.case.address?.zipCode)
    };
    
    let params2: IParamsCollection = {
      filter: FilterBuilder.fromObject(filters2).build(),
    };
    let response2 = await firstValueFrom(this.zonesLinesService.all(params2));
    this.postalCodeNotInZonesFromCompany = response2.data.length == 0;
  }


  ngOnDestroy(): void {
    if (this.routerSubscription) {
      this.routerSubscription.unsubscribe();
    }
    if(this.presenceTimeout) clearTimeout(this.presenceTimeout);
    document.removeEventListener('scroll', this.onContentScroll, true);
  }

  //al bajar se cierra "Datos generales" (abierto por defecto). El scroll ya no es de la ventana sino del
  //contenedor del router-outlet, y el evento scroll no burbujea: se escucha en captura y se ignora el de
  //cualquier otro elemento con scroll propio (tablas, diálogos...) que no contenga la cabecera.
  //al abrir "Datos generales" con la página bajada, la cabecera sticky crece y el scroll anchoring del navegador
  //sube el scrollTop: ese scroll no es del usuario y cerraría la pestaña nada más abrirla. Se ignora mientras
  //dura la animación del acordeón (400ms por defecto en PrimeNG).
  private lastContentScrollTop = 0;
  private ignoreContentScrollUntil = 0;
  private onContentScroll = (event: Event) => {
    const scroller = event.target;
    const header = document.getElementById('case-header');
    if (!(scroller instanceof HTMLElement) || header == null || !scroller.contains(header)) return;

    const scrollTop = scroller.scrollTop;
    const generalTab = this.accordionDetailsTab?.tabs[0];
    if (scrollTop > this.lastContentScrollTop && scrollTop > 25 && generalTab?.selected
      && Date.now() >= this.ignoreContentScrollUntil) {
      generalTab.toggle();
    }
    this.lastContentScrollTop = scrollTop;
  };

  onGeneralDataOpen() {
    this.ignoreContentScrollUntil = Date.now() + 500;
  }

  @HostListener('window:beforeunload', ['$event'])
  handleClose($event:any) {
    $event.preventDefault();
    $event.returnValue = '¿estás seguro de que quieres salir?';
  }

  goToAccordionTab(index: number): void {
    if (this.accordionDetailsTab?.tabs[0].selected) {
      this.accordionDetailsTab.tabs[0].toggle();
    }
    if (this.accordionTabs?.tabs[0].selected) {
      this.accordionTabs.tabs[0].toggle();
    }
    this.accordionTabs?.tabs.forEach(tab => {
      if (tab.selected) {
        tab.toggle();
      }
    });
    if (!this.accordionTabs?.tabs[index].selected) {
      this.accordionTabs.tabs[index].toggle();
    }

    // Offset scroll by sticky header height so the destination tab is not hidden.
    setTimeout(() => {
      const headers = document.querySelectorAll('#accordion-tabs .p-accordionheader');
      const targetHeader = headers.item(index) as HTMLElement | null;
  
      if (!targetHeader) return;    
      const stickyHeader = document.getElementById('case-header');
      const targetY = parseInt(targetHeader.getBoundingClientRect().top.toString()) - window.screenTop - 140;
      window.scrollTo({
        top: Math.max(0, targetY),
        behavior: 'smooth'
      });
    }, 300);
    
  }

  goToAccordionTabFromSidebar(index: number): void {
    this.optionsSidebarVisible = false;
    this.goToAccordionTab(index);
  }

  async loadNotifications(id: string){
    
    this.filters.readedAt = new Filter(FilterOperation.equals, 'readedAt', '', null, true);
    this.filters.source = new Filter(FilterOperation.equals, 'source', '', 2);
    this.filters.sourceId = new Filter(FilterOperation.equals, 'sourceId', '', id);
    
    let params: IParamsCollection = {
      sort: ['createdAt'],
      include: ['user'],
      filter: FilterBuilder.fromObject(this.filters).build()
    };

    let response = await firstValueFrom(this.notificationsService.all(params));
    this.notifications = response.data;    

    if(this.notifications.length > 0){
      this.showNotifications = true;
    }
    
  }

  async loadPendingLogs(id: string, showModal:boolean){
    
    let filters: any = {      
      direction: new Filter(FilterOperation.equals, "direction", '', "In"),
      caseLogTypeId: new NotFilter(FilterOperation.equals, "caseLogTypeId", '', null, true),
      caseId: new Filter(FilterOperation.equals, 'caseId', '', id),
      completedAt: new Filter(FilterOperation.equals, 'completedAt', '', null, true)
    };    

    let params: IParamsCollection = {
      sort: ['-date'],      
      filter: FilterBuilder.fromObject(filters).build(),      
    }        

    let response = await firstValueFrom(this.casesLogsService.all(params));
    let pendingLogs = response.data;    
    if(pendingLogs.length > 0){
      this.hasPendingLogs = true;
      if(showModal) this.showPendingLogsModal = true;
    }else{
      this.hasPendingLogs = false;
      this.showPendingLogsModal = false;
    }
    
  }  

  async loadCase(id: string) {
    this.case = await firstValueFrom(this.casesService.get(id, { include: ['company', 'client.clientSubType', 'processor', 'address', 'caseState', 'caseType', 'contract.integration', 'contract.business', 'clientPolicy.insuranceCompany', 'caseTreatment'] }));
    
    this.loadHasCaseResume(id);
    this.loadHasCaseAgentInforme(id);

    //todas las acciones que se registren desde aquí pertenecen a este expediente
    this.auditContextService.setCase(id);

    //guardamos el estado original
    this.originalCaseState = this.case.caseState

    //calculamos la distancia al centro de la ciudad
    firstValueFrom(this.casesService.distanceToCityCenter(this.case.id!)).then(d => this.distanceToCityCenter = d);
    
    this.topbarService.setWindowTitle(this.case.caseNumber + " - " + this.case.client?.name);

    if(this.case.revisionDate != null){
      this.revisionDate = this.case.revisionDate;
    }
    this.onTabChange({ index: 0, originalEvent: new Event('') });

    //Buscamos si hay mas expedientes relacionados con este. El criterio (póliza, o asegurado +
    //dirección) se configura por empresa y lo resuelve el backend, que ademas filtra sin los
    //permisos de visibilidad del usuario: con .all() no veían las cosas correctamente.
    let relatedCases = await firstValueFrom(this.casesService.getRelatedCases(this.case.id!));
    this.relatedCasesCriteria = relatedCases.criteria;
    this.relatedCasesCount = relatedCases.count;
    this.relatedCasesIds = relatedCases.caseIds ?? [];

    
    this.caseFormGroup.patchValue(this.case);
    if(this.case.addressId != null && this.case.address?.zipCode != null && this.case.contractId!=null){
      //buscamos si este zipcode esta en las zonas del contrato.
      this.loadContractZones(this.case.contractId);
      //Descripción del motivo de anulación (vive en el metadata del caseState)
      this.cancelReasonDescription = null;
      if(this.case.caseState?.code?.toUpperCase() == 'CANCELED' && this.case.caseStateMetadata){
        try{
          this.cancelReasonDescription = JSON.parse(this.case.caseStateMetadata)?.cancelReasonDescription ?? null;
        }catch(e){
          //console.error("caseStateMetadata no es JSON válido", e);
        }
      }
    }

  }

  async loadHasCaseResume(id: string) {
    let filter = {
      caseId: new Filter(FilterOperation.equals, 'caseId', '', id)
    };
    let params: IParamsCollection = {
      page: { size: 1 },
      filter: FilterBuilder.fromObject(filter).build()
    };
    let response = await firstValueFrom(this.casesResumesService.all(params));
    this.hasCaseResume = response.data.length > 0;
  }

  //el informe pericial no se guarda en la sesión: se localiza por el nombre del fichero,
  //que el servicio en background genera como ia_informe_pericial_{sessionId}.pdf.
  //El prefijo va sin el guion bajo final para contar también los informes anteriores a S1.
  async loadHasCaseAgentInforme(id: string) {
    let filter = {
      caseId: new Filter(FilterOperation.equals, 'caseId', '', id),
      fileName: new Filter(FilterOperation.startsWith, 'file.fileName', '', 'ia_informe_pericial')
    };
    let params: IParamsCollection = {
      page: { size: 1 },
      filter: FilterBuilder.fromObject(filter).build()
    };
    let response = await firstValueFrom(this.casesFilesService.all(params));
    this.hasCaseAgentInforme = response.data.length > 0;
  }

  async updatePresence() {
    if(this.case.id!=null && this.case.lastActionDate){
      let response:User = await firstValueFrom(this.casesService.updatePresence(this.case.id!));
      if(response!=null && response.id != this.currentUser?.id){
        this.otherUserConnected = response;
      }else{
        this.otherUserConnected = null;
      }
    }
    this.presenceTimeout = setTimeout(async() => {
      await this.updatePresence();
    }, 2 * 60 * 1000);
  }
  
  async loadServicesTypes(){
    let params:IParamsCollection = {
      include: ['serviceType']
    }   
    let filters: any = {
      companyId: new OrFilter([
        new Filter(FilterOperation.equals, 'companyId', '', this.case.companyId),
        new Filter(FilterOperation.equals, 'companyId', '', null, true)
      ]),
      contractId: new OrFilter([
          new Filter(FilterOperation.equals, 'contractId', '', this.case.contractId),
          new Filter(FilterOperation.equals, 'contractId', '', null, true)
      ])
    }; 
    params.filter = FilterBuilder.fromObject(filters).build();
    let response = await firstValueFrom(this.servicesTypesCompanyService.all(params));
    this.servicesTypes = response.data.filter((v, i, a) => a.findIndex(t => (t.id === v.id)) === i);
    
    let aux = await firstValueFrom(this.caseServiceTypesService.all({ filter: FilterBuilder.fromObject({caseId: new Filter(FilterOperation.equals, 'caseId', '', this.case.id)}).build() }));
    this.selectedServiceTypes = aux.data.map(m => m.serviceTypeId);
  }

  public async loadCaseModes(): Promise<string | null>{
    
    if(this.case.caseModeId == null) return null;
    var response = await firstValueFrom(this.caseModeService.get(this.case.caseModeId));
   return response.code;
    
  }


  async loadCaseStates() {
    const filters: { [key: string]: any } = {
      //isFinal: new NotFilter(FilterOperation.equals, 'isFinal', '', true)
    };
    
    this.caseModeCode = await this.loadCaseModes();
    if(this.caseModeCode!=null){
      //filtro por relacion: pendiente de verificar contra la API que JsonApiDotNetCore acepte la cadena caseMode.code dentro de has()
      filters["caseMode"] = new HasFilter('caseModes',
        new Filter(FilterOperation.equals, 'caseMode.code', '', this.caseModeCode));
    }
    if(this.case?.caseStateId){
      filters['isFinal'] = new OrFilter([
        new Filter(FilterOperation.equals, 'isFinal', '', false),
        new Filter(FilterOperation.equals, 'id', '', this.case.caseStateId)
      ]);
    }else{
      filters['isFinal'] = new Filter(FilterOperation.equals, 'isFinal', '', false);
    }    
    let params: IParamsCollection = {
      sort: ['name'],
      filter: FilterBuilder.fromObject(filters).build()
    };
    let response = await firstValueFrom(this.casesStatesService.all(params));
    this.caseStates = response.data;
  }

  /// Submódulo de trazabilidad de cada pestaña del acordeón, en el mismo orden que los índices de abajo.
  private readonly auditSubmodulesByTabIndex: string[] = [
    AuditSubmodules.APPOINTMENTS, AuditSubmodules.EVENTS, AuditSubmodules.JOBS, AuditSubmodules.BUDGETS,
    AuditSubmodules.ATTACHMENTS, AuditSubmodules.AFFECTED, AuditSubmodules.EXPERTS, AuditSubmodules.TECHNICALS,
    AuditSubmodules.MEDIATORS, AuditSubmodules.NOTES, AuditSubmodules.PURCHASES, AuditSubmodules.INCIDENTS,
    AuditSubmodules.CLAIMS, AuditSubmodules.REFUNDS
  ];

  async onTabChange(event: AccordionTabOpenEvent) {
    //dejamos constancia del submódulo activo para que las acciones que se registren lo lleven de contexto
    this.auditContextService.setSubmodule(this.auditSubmodulesByTabIndex[event.index] ?? null);

    if (event.index == 0) {
      //services
      this.loadServices();
      this.loadTransactionsBudget();
      this.loadTransactionsPurchase();
    } else if (event.index == 1) {
      //communications
      this.loadLogs(this.lastGridLogEvent);
    } else if (event.index == 2) {
      //trabajos realizados
      this.casesJobsComponent.reload();
      //tambien requiere solicitudes de compra
      this.loadTransactionsPurchase();
    } else if (event.index == 3) {
      //presupuestos
      this.loadTransactionsBudget()
    }
    else if (event.index == 4) {
      //Adjuntos
      this.loadCaseFiles();
    } else if (event.index == 5) {
      //affecteds
      this.loadAffecteds();
    } else if (event.index == 6) {
      //experts
      this.loadCaseExperts();
    } else if (event.index == 7) {
      // technicals
      this.loadCaseTechnicals(this.lastGridCaseTechnicals);
    } else if (event.index == 8) {
      //Mediadores
      this.loadCaseMediators(this.lastGridCaseMediators);     
    }  else if (event.index == 9) {
       //notes
      this.loadNotes(this.lastGridCaseNotes);     
    }  
    else if (event.index == 10) {
       //Solicitudes de compra
      this.loadTransactionsPurchase();      
    }   
    else if (event.index == 11) {
      //Adjuntos
      this.loadCaseIncidents(this.lastGridCaseIncident);     
    }
    else if (event.index == 12) {
       //Adjuntos
      this.loadNotesClient(this.lastGridCaseNotesClient);
    }if (event.index == 13) {
      //Devoluciones
      this.loadCompensationTransactions();
    }
  }

  async loadAffecteds() {

    this.loadingAffecteds = true;
    let params: IParamsCollection = {
      include: ['address']
    }
    let filters: any = {
      caseId: new Filter(FilterOperation.equals, "caseId", "", this.case.id),
    };
    params.filter = FilterBuilder.fromObject(filters).build();

    let response = await firstValueFrom(this.affectedsService.all(params));
    this.totalAffecteds = response.data;    
    this.totalAffectedsRecords = response.meta['total'];
    this.countAffecteds = this.totalAffectedsRecords;
    this.loadingAffecteds = false;
  }

  async loadCaseExperts() {
    this.loadingExperts = true;
    let params: IParamsCollection = {
      include: ['expert', 'expert.address']
    }
    let filters: any = {

      caseId: new Filter(FilterOperation.equals, "caseId", "", this.case.id),
    };
    params.filter = FilterBuilder.fromObject(filters).build();

    let response = await firstValueFrom(this.casesExpertsService.all(params));
    this.caseExperts = response.data;
    this.totalExpertsRecords = response.meta['total'];
    this.loadingExperts = false;
    this.countExperts = this.totalExpertsRecords;
    this.caseExpertsHeader = response.data.filter(m => m.isActive);
  }

  async loadCaseTechnicals($event?: any) {
 
    this.lastGridCaseTechnicals = $event;
    //si no esta abierta la pestaña de logs, no cargamos nada
    if(!this.accordionTabs?.tabs[7].selected) return;

    this.loadingTechnicals = true;
    let params: IParamsCollection = {
      include: ['user'],
      page: { number: this.lastGridCaseTechnicals.first + 1, size: this.lastGridCaseTechnicals.rows },
    }
    if (typeof this.lastGridCaseTechnicals.sortField != "undefined") params.sort = [(this.lastGridCaseTechnicals.sortOrder > 0 ? "-" : "") + this.lastGridCaseTechnicals.sortField];

    let filters: any = {
      caseId: new Filter(FilterOperation.equals, "caseId", "", this.case.id),
    };
    params.filter = FilterBuilder.fromObject(filters).build();

    let response = await firstValueFrom(this.caseUsersService.all(params));
    this.caseTechnicals = response.data;
    this.totalTechnicalsRecords = response.meta['total'];
    this.loadingTechnicals = false;
    this.countTechnicals = this.totalTechnicalsRecords;
  }


  async loadNotes($event: any) {
    this.lastGridCaseNotes = $event;

    //si no esta abierta la pestaña de logs, no cargamos nada
    if(!this.accordionTabs?.tabs[9].selected) return;
    
    this.loadingNotes = true;

    let params: IParamsCollection = {
      include: ['createdByUser','tasks','tasks.comments','tasks.comments.createdByUser'],
      sort: ['-date'],
      page: { number: this.lastGridCaseNotes.first + 1, size: this.lastGridCaseNotes.rows },
    }
    let filters: any = {
      caseId: new Filter(FilterOperation.equals, "caseId"),
      caseNoteType: new Filter(FilterOperation.equals, "caseNoteType"),
    };
    if (typeof this.lastGridCaseNotes.sortField != "undefined") params.sort = [(this.lastGridCaseNotes.sortOrder > 0 ? "-" : "") + this.lastGridCaseNotes.sortField];
    filters.caseId.value = this.case.id;
    filters.caseNoteType.value = "0";
    params.filter = FilterBuilder.fromObject(filters).build();
    let response = await firstValueFrom(this.casesNotesService.all(params));
    this.caseNotes = response.data;
    this.totalNotesRecords = response.meta['total'];   
    this.countNotes = this.totalNotesRecords; 
    this.loadingNotes = false;

  }

  async editClientDetail(){
    let ref = this.dialogService.open(ClientsDetailComponent, {
      closable: true,
      header: 'Editar cliente',
      width: '900px',
      draggable: true,
      modal: false,
      data: {
        id: this.case.clientId
      }
    });  
    ref.onClose.subscribe(async (data: Client) => {      
      if(data != null && this.case != null && this.case.client != null){
        this.case.client.bankAccountId = data.bankAccountId;
      } 
      await this.loadClientBankAccounts();
    });
  }

  async loadNotesClient($event: any) {
    this.lastGridCaseNotesClient = $event;
    
    //si no esta abierta la pestaña de logs, no cargamos nada
    if(!this.accordionTabs?.tabs[12].selected) return;
    this.loadingNotes = true;


    let params: IParamsCollection = {
      page: { number: this.lastGridCaseNotesClient.first + 1, size: this.lastGridCaseNotesClient.rows },
    }
    //Notas de cliente
    let filters: any = {
      caseId: new Filter(FilterOperation.equals, "caseId"),
      caseNoteType: new NotFilter(FilterOperation.equals, "caseNoteType"),
    };
    if (typeof this.lastGridCaseNotesClient.sortField != "undefined") params.sort = [(this.lastGridCaseNotesClient.sortOrder > 0 ? "-" : "") + this.lastGridCaseNotesClient.sortField];
    filters.caseId.value = this.case.id;
    filters.caseNoteType.value = "0";
    params.filter = FilterBuilder.fromObject(filters).build();
    let response = await firstValueFrom(this.casesNotesService.all(params));
    this.caseNotesClient = response.data;
    this.totalNotesClientRecords = response.meta['total'];
    this.loadingNotes = false;
    this.countNotesClient = this.totalNotesClientRecords;
  }

  async loadServices() {
    this.loadingServices = true;
    let params: IParamsCollection = {
      sort: ['date']
    }
    let filters: any = {
      caseId: new Filter(FilterOperation.equals, "caseId"),
    };

    filters.caseId.value = this.case.id;
    params.filter = FilterBuilder.fromObject(filters).build();
    params.include = ['worker', 'equipment', 'capability', 'cancelCaseServiceReason', 'cancelCaseServiceCause', 'caseNotificationNumber', 'materials.material'];

    let response = await firstValueFrom(this.casesServicesService.all(params));
    this.caseServices = response.data;
    this.totalServicesRecords = response.meta['total'];
    this.loadingServices = false;
    this.loadFilesDocuments();
  }

  async loadFilesDocuments(){
    let params: IParamsCollection = {
      include: ['file', 'caseFileCategory'],
      sort: ['-createdAt']
    }
    
    let filters: any = {
      caseId: new Filter(FilterOperation.equals, "caseId"),
      caseFileCategoryId: new Filter(FilterOperation.equals, "caseFileCategory.showInMobile", '', false)
    };

    filters.caseId.value = this.case.id;
    params.filter = FilterBuilder.fromObject(filters).build();

    let response = await firstValueFrom(this.casesFilesService.all(params));
    this.caseFiles = response.data;
    this.caseFiles.forEach((item: any) => {
      item.actions = [
          {
            label: 'Descargar',
            icon: 'pi pi-download',
            command: () => this.downloadFile(item.fileId)
          },
          {
            label: 'Editar',
            icon: 'pi pi-pencil',
            command: () =>{ 
              this.editCaseFile(item);
            }
          },
          {
            label: 'Eliminar',
            icon: 'pi pi-trash',
            command: () => this.deleteCaseFile(item)
          }
        ];
    });
    this.caseServices.forEach((item: any) => {
      item.files = this.caseFiles.filter((file: any) => file.caseServiceId == item.id);
      
    });
  }


  async loadJobs() {    
        
    let params: IParamsCollection = {  
      page: { number: 1, size: 200 } //hay servicios que tienen mas de 100 trbajo. ejemplo 3524010456
    }
    let filters: any = {      
      caseId: new Filter(FilterOperation.equals, "caseId",'',this.case.id),   
      //caseServiceDeleted: new Filter(FilterOperation.equals, "caseService.deleted", '', false) 
       caseService: new OrFilter([
                new Filter(FilterOperation.equals, "caseService.deleted", '', false),
                new Filter(FilterOperation.equals, "caseServiceId", '', null, true)
              ])
      //workerId: new Filter(FilterOperation.equals, "caseService.workerId",'',this.caseService.workerId)   
    };

    params.filter = FilterBuilder.fromObject(filters).build();    

    let response = await firstValueFrom(this.jobsService.all(params));
    this.jobs = response.data;
    this.AIGeneratedJobs = this.jobs.filter((job:any) => job.isIAGenerate && !job.isForCompany).length;  
    var aux = this.jobs.filter((m:any) => m.isIAGenerate && !m.isForCompany).filter((v:any, i:any, a:any) => a.findIndex((t:any) => (t.caseServiceId === v.caseServiceId)) === i);
    this.AIGeneratedJobsMessage = "En este expediente, la IA te ha sugerido para " + aux.length +" de "+ this.caseServices.length + " citas un total de "+this.AIGeneratedJobs+" líneas de baremo";

    //Comprobamos si este contrato/tipo de daño tiene dias de garantía que ya hayan pasado, si es así avisamos
    if(this.jobs.length > 0 && this.case.caseTypeId != null && this.case.contractId != null){
       var lastJob = this.jobs.sort((a:any, b:any) => new Date(b.date).getTime() - new Date(a.date).getTime())[0];
      //obtenemos 
      //tramos todos los tipos de casos
      let filters = {
        contractId: new Filter(FilterOperation.equals, 'contractId', "", this.case.contractId),
        caseTypeId: new Filter(FilterOperation.equals, 'caseTypeId', "", this.case.caseTypeId)
      };    
      let params: IParamsCollection = { }
  
      //creamos filtros
      params.filter = FilterBuilder.fromObject(filters).build();
      let response2 = await firstValueFrom(this.contractCaseTypesService.all(params));
      let endMoment = moment(lastJob.date);
      let duration = moment.duration(moment().diff(endMoment));
      let durationDays = duration.asDays();
      if(response2.data.length > 0 && response2.data[0].daysGuarantes > 0 &&  durationDays > response2.data[0].daysGuarantes){
        this.messageGuarantee = 'IMPORTANTE: Los trabajos realizados ya no se encuentran en garantía. Han pasado más de ' + response2.data[0].daysGuarantes + ' días desde el último trabajo realizado.';
      }else this.messageGuarantee = "";
    }

  }

  hasPolicyFranchise(){
    let hasPolicy = false;
    if(this.case.clientPolicy!=null && this.case.clientPolicy?.franchisePrice!=null && this.case.clientPolicy?.franchisePrice!=''){
      if(this.case.clientPolicy?.franchisePrice!='0') hasPolicy = true;
    }
    return hasPolicy;
  }
  
  async loadTransactionsBudget() {
    this.loadingTransactionsBudget = true;
    let paramsBudget: IParamsCollection = {
      include: ['transactionState', 'thirdParty', 'transactionType', 'relatedTransaction', 'caseService', 'createdByUser', 'caseService.worker'],
       fields: {
        //caseServices: ['id', 'date'],
        workers: ['id', 'name'],
        users: ['id', 'name'],
      }
    }
    let filters: any = {
      caseId: new Filter(FilterOperation.equals, "caseId"),
      transactionTypeCode: new Filter(FilterOperation.any, "transactionType.code", '', ['company_outgoing_budget', 'ingoing_budget_worker', 'outgoing_budget', 'affected_outgoing_budget'])
    };
    filters.caseId.value = this.case.id;
    
    //filters.transactionTypeCode.value = "outgoing_budget";
    paramsBudget.filter = FilterBuilder.fromObject(filters).build();
    
    let response = await firstValueFrom(this.transactionsService.all(paramsBudget));
    
    this.caseTransactionsBudget = response.data;

    //boton de eliminar para cada uno de ellos...
    this.caseTransactionsBudget.forEach((transaction: any) => {
      var auxAllowDelete = this.allowDelete;
      if (transaction.transactionType.code=='ingoing_budget_worker'){
        //si es ppto de operario y lo ha creado el operario, no puede borrarse
        if(transaction.createdByUser?.isWorker) auxAllowDelete = false;
      }  
      transaction.deleteButton =  auxAllowDelete && transaction.id && (transaction.netSuiteId == null);
    });

    var workerBudget = this.caseTransactionsBudget.filter((m:any) => m.transactionType.code == 'ingoing_budget_worker' && m.transactionState.code != 'refused' && m.forProfitability);
    var outgoingBudget = this.caseTransactionsBudget.filter((m:any) => m.transactionType.code != 'ingoing_budget_worker' && m.transactionState.code != 'refused' && m.forProfitability);
    var budgetTotalInbound = 0;
    var budgetTotalOutgoing = 0;
    if(workerBudget.length > 0){
      budgetTotalInbound = parseFloat(workerBudget.reduce((a:number, t: any) => a + parseFloat(t.subtotal), 0));
    }
    if(outgoingBudget.length > 0){
      budgetTotalOutgoing = parseFloat(outgoingBudget.reduce((a:number, t: any) => a + parseFloat(t.subtotal), 0));
    }
    //tenemos en cuenta las solicitudes de compras que cuenten en profitability
    var purchaseOrderBudget = this.caseTransactionsPurchase.filter((m:any) => m.transactionType.code == 'purchase_order' && m.transactionState.code != 'refused' && m.forProfitability);
     var purchaseOrderBudgetTotal = 0;
    if(purchaseOrderBudget.length > 0){
      purchaseOrderBudgetTotal = parseFloat(purchaseOrderBudget.reduce((a:number, t: any) => a + parseFloat(t.subtotal), 0));
    }

    this.caseTransactionsBudgetResume = budgetTotalOutgoing - budgetTotalInbound - purchaseOrderBudgetTotal;
    this.caseTransactionsBudgetResumePercent = 0;
    if(budgetTotalOutgoing > 0 && budgetTotalInbound == 0) {
      this.caseTransactionsBudgetResumePercent = 100;
    }else{
      this.caseTransactionsBudgetResumePercent = budgetTotalOutgoing > 0 ? (this.caseTransactionsBudgetResume * 100) / budgetTotalOutgoing : 0;
    }
    this.totalTransactionsBudgetRecords = response.meta['total'];
    this.loadingTransactionsBudget = false;
  }

  async reloadTransactionsBudget(event: any,transaction:Transaction){
    await this.transactionsService.save(transaction).subscribe({
      next: (data) => {
        //this.messageService.add({ severity: 'success', summary: 'Éxito', detail: 'Comunicación completada correctamente' });
        this.loadTransactionsBudget();
      },
      error: (error) => {
        this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Error al guardar si cuenta para la rentabilidad o no en la transacción' });
      }
    });
   
  }


  async loadTransactionsPurchase() {    

    this.loadingTransactionsPurchase = true;
    let paramsPurchase: IParamsCollection = {
      include: ['transactionState', 'thirdParty', 'transactionType']
    }
    let filtersPurchase: any = {
      caseId: new Filter(FilterOperation.equals, "caseId"),
      transactionTypeCode: new Filter(FilterOperation.equals, "transactionType.code")
    };
    filtersPurchase.caseId.value = this.case.id;
    filtersPurchase.transactionTypeCode.value = "purchase_order";
    paramsPurchase.filter = FilterBuilder.fromObject(filtersPurchase).build();
    let responsePurchase = await firstValueFrom(this.transactionsService.all(paramsPurchase));
    this.caseTransactionsPurchase = responsePurchase.data;    
    this.totalTransactionsPurchaseRecords = responsePurchase.meta['total'];
    this.loadingTransactionsPurchase = false;
    this.countTransactionsPurchase = this.totalTransactionsPurchaseRecords;
  }


  async loadTransactionsWorkerInvoice() {    

    let params: IParamsCollection = {
      include: ['transactionState', 'thirdParty', 'transactionType']
    }
    let filtersPurchase: any = {
      caseId: new Filter(FilterOperation.equals, "caseId"),
      transactionTypeCode: new Filter(FilterOperation.equals, "transactionType.code")
    };
    filtersPurchase.caseId.value = this.case.id;
    filtersPurchase.transactionTypeCode.value = "incoming_invoice";
    params.filter = FilterBuilder.fromObject(filtersPurchase).build();
    let response = await firstValueFrom(this.transactionsService.all(params));
    
    this.caseTransactionsWorkerInvoice = response.data;
  }

  async loadCaseFiles() {
    let params: IParamsCollection = {
      include: ['file', 'caseFileCategory'],
      sort: ['-createdAt'],
      page: { size: 1000 } //Existen servicios que tienen mas de 100 archivos (por ejem 2025/1123095)
    }
    
    let filters: any = {
      caseId: new Filter(FilterOperation.equals, "caseId"),
      caseFileCategoryId: new Filter(FilterOperation.equals, "caseFileCategoryId")
    };

    filters.caseId.value = this.case.id;
    if (this.caseFileCategoryFilter != "all") {
      filters.caseFileCategoryId.value = this.caseFileCategoryFilter;
    }

    params.filter = FilterBuilder.fromObject(filters).build();

    let response = await firstValueFrom(this.casesFilesService.all(params));
    this.caseFiles = response.data;
    this.countCaseFiles = response.meta['total'];

    this.caseFilesServices = [];
    this.caseFilesWithoutService = [];
    this.caseFilesInsured = [];
    this.caseFiles.forEach((caseFile: any) => {
      caseFile.actions = [
            {
              label: 'Descargar',
              icon: 'pi pi-download',
              command: () => this.downloadFile(caseFile.fileId)
            },
            {
              label: 'Editar',
              icon: 'pi pi-pencil',
              command: () =>{ 
                this.editCaseFile(caseFile);
              }
            },
            {
              label: caseFile.showMobile ? 'No mostrar en la app' : 'Mostrar en la app',
              icon: 'pi pi-mobile',
              command: () => this.toggleCaseFileVisibility(caseFile, 'showMobile')
            },
            {
              label: caseFile.showCaseTracking ? 'No mostrar en sigue tu expediente' : 'Mostrar en sigue tu expediente',
              icon: 'pi pi-eye',
              command: () => this.toggleCaseFileVisibility(caseFile, 'showCaseTracking')
            },
            {
              label: 'Eliminar',
              icon: 'pi pi-trash',
              command: () => this.deleteCaseFile(caseFile)
            }
          ];

      if (caseFile.caseServiceId) {
        let caseService = this.caseServices.find((service: CaseService) => service.id == caseFile.caseServiceId);
        this.caseFilesServices.push({
          id: caseService?.id,
          name: (caseService?.worker?.name + " - " + caseService?.date.toLocaleString(
            'es-ES',
            {
              year: 'numeric',
              month: '2-digit',
              day: '2-digit',
              hour: '2-digit',
              minute: '2-digit'
            }
          ))
          
        });
      } else if (caseFile.source == 'Client') {
        this.caseFilesInsured.push(caseFile);
      } else {   
        this.caseFilesWithoutService.push(caseFile);
      }
    });
    // quitar duplicados
    this.caseFilesServices = this.caseFilesServices.filter((v, i, a) => a.findIndex(t => (t.id === v.id)) === i);

    //agrupamos los adjuntos "Generales" en una fila por sesión de videoperitación
    if (!this.agentSessionsLoaded) {
      await this.loadAgentSessions();
      this.agentSessionsLoaded = true;
    }
    this.buildGeneralFileGroups();
  }

  //carga (una sola vez) las sesiones de videoperitación del expediente para poder cruzar sus adjuntos
  async loadAgentSessions() {
    try {
      let params: IParamsCollection = {
        filter: FilterBuilder.fromObject({
          caseId: new Filter(FilterOperation.equals, "caseId", "", this.case.id)
        }).build()
      };
      let response = await firstValueFrom(this.caseAgentFlowSessionsService.all(params));
      this.agentSessions = response.data;
    } catch {
      //si no se pueden cargar las sesiones, los adjuntos caen al grupo "sin sesión" (comportamiento previo)
      this.agentSessions = [];
    }
  }

  //agrupa caseFilesWithoutService en: un grupo sin sesión (adjuntos manuales) + un grupo por sesión de videoperitación
  private buildGeneralFileGroups() {
    //índice por los DOS identificadores de una sesión: Id (prefijo de las fotos) y SessionId (id de recopilación de los PDFs)
    const sessionByToken = new Map<string, any>();
    for (const s of this.agentSessions) {
      if (s.id) sessionByToken.set(String(s.id).toLowerCase(), s);
      if (s.sessionId) sessionByToken.set(String(s.sessionId).toLowerCase(), s);
    }

    const GENERAL_KEY = "__general__";
    const groupByKey = new Map<string, { key: string; label: string | null; files: any[] }>();
    const groups: { key: string; label: string | null; files: any[] }[] = [];

    for (const file of this.caseFilesWithoutService) {
      const session = this.matchSessionForFile(file, sessionByToken);
      const key = session ? String(session.id) : GENERAL_KEY;
      let group = groupByKey.get(key);
      if (!group) {
        group = { key, label: session ? this.agentSessionLabel(session) : null, files: [] };
        groupByKey.set(key, group);
        groups.push(group);
      }
      group.files.push(file);
    }

    //el grupo sin sesión (adjuntos manuales) primero; después una fila por sesión (más reciente arriba, ya vienen por -createdAt)
    groups.sort((a, b) => (a.key === GENERAL_KEY ? -1 : b.key === GENERAL_KEY ? 1 : 0));
    this.caseFilesGeneralGroups = groups;
  }

  //asocia un adjunto a su sesión según el nombre de fichero: PDFs 'ia_(informe_pericial|parte_asistencia)_{recopilacionId}.pdf'
  //y fotos '{sessionId}_...' (el prefijo es el CaseAgentFlowSession.Id). Devuelve null si no casa con ninguna sesión.
  private matchSessionForFile(file: any, sessionByToken: Map<string, any>): any | null {
    const name = (file?.file?.fileName ?? "").toLowerCase();
    if (!name) return null;
    const guid = "[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}";
    let m = name.match(new RegExp(`^ia_(?:informe_pericial|parte_asistencia)_(${guid})\\.pdf$`));
    if (m) return sessionByToken.get(m[1]) ?? null;
    m = name.match(new RegExp(`^(${guid})_`));
    if (m) return sessionByToken.get(m[1]) ?? null;
    return null;
  }

  //etiqueta de cabecera de cada fila de sesión
  private agentSessionLabel(session: any): string {
    let label = "Videoperitación";
    if (session?.createdAt) {
      const d = new Date(session.createdAt);
      if (!isNaN(d.getTime())) {
        label += " · " + d.toLocaleString("es-ES", { day: "2-digit", month: "2-digit", year: "numeric", hour: "2-digit", minute: "2-digit" });
      }
    }
    return label;
  }

  async loadCaseFileCategories() {
    let allCategories = new CaseFileCategory();
    allCategories.id = "all";
    allCategories.name = "Todos";
    let response = await firstValueFrom(this.caseFileCategoriesService.all());
    this.caseFileCategories = response.data;
    this.caseFileCategories.unshift(allCategories);
  }

  onFileCategoryFilterChange() {
    this.loadCaseFiles();
  }


  cancel() {
    this.router.navigate(['cases']);
  }

  editGeneral($event: any) {
    $event?.stopPropagation();
    const ref = this.dialogService.open(CasesDetailGeneralComponent, {
      closable: true,
      header: 'Datos generales',
      width: '60%',
      draggable: true,
      modal: false,
      data: {
        id: this.case.id
      }
    });

    ref.onClose.subscribe(async () => {
      
      await this.loadCase(this.case.id as string);
      
      this.loadCaseStates();
      this.caseModeCode = await this.loadCaseModes(); //por si han cambiado el tipo de expediente de "siniestro a siniestro grave" o viceversa.
      await this.validateSeriousSinisterCaseHasTechnicals();
    });
  }

  editState() {
    let ref = this.dialogService.open(CaseStateComponent, {
      closable: true,
      header: 'Estado del expediente',
      width: '500px',
      draggable: true,
      modal: false,
      data: {
        id: this.case.id
      }
    });

    ref.onClose.subscribe((data: any) => {
      this.loadCase(this.case.id as string);
    });
  }

  async openDeclarationModal($event: any) {
    $event?.stopPropagation();
    this.showDeclarationModal=true;
  }

  async editProcessor($event: any) {
    $event?.stopPropagation();
    let ref = this.dialogService.open(CasesDetailProcessorComponent, {
      closable: true,
      header: 'Tramitador',
      width: '700px',
      draggable: true,
      modal: false,
      data: {
        id: this.case.processorId
      }
    });

    ref.onClose.subscribe(async (data: Client) => {
      if (data != null) {
        this.case.processorId = data.id as string;
        await firstValueFrom(this.casesService.save(this.case));
        this.loadCase(this.case.id as string);
      }
    });
  }

  async deleteProcessor() {
    this.case.processorId = "";
    await firstValueFrom(this.casesService.save(this.case));
    this.loadCase(this.case.id as string);
  }

  async deleteClient() {
    this.case.clientId = "";
    await firstValueFrom(this.casesService.save(this.case));
    this.loadCase(this.case.id as string);
  }

  viewClient() {
    this.router.navigate(['clients', this.case.clientId]);
  }

  async editAffected(affected: Affected | null) {
    let ref = this.dialogService.open(CasesDetailAffectedComponent, {
      closable: true,
      header: 'Ficha de implicado',
      width: '80%',
      draggable: true,
      modal: false,
      data: {
        caseId: this.case.id,
        affectedId: affected ? affected.id : null
      }
    });

    ref.onClose.subscribe((data: any) => {
      this.loadAffecteds();
    });
  }

  async deleteAffected(id: any) {
    this.confirmationService.confirm({
      message: "¿Está seguro que desea eliminar el perjudicado?",
      header: "Eliminar perjudicado",
      acceptLabel: "Aceptar",
      rejectLabel: "Cancelar",
      acceptButtonStyleClass: "p-button-danger",
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
        this.affectedsService.delete(id).subscribe({
          next: (data: any) => {
            this.messageService.add({ closable: true, severity: 'success', detail: "Perjudicado eliminado correctamente." });
            this.loadAffecteds();
          },
          error: (error: any) => {
            this.messageService.add({ closable: true, severity: 'error', detail: error.error.title });
          }
        });
      },
      reject: (error: any) => {
        this.messageService.add({ closable: true, severity: 'error', detail: error.error.title });
      }
    });
  }

  async editTransaction(transactionType: string, transaction: any) {
    //this.router.navigate(['transactions/' + transactionType + '/' + (transaction && Object.keys(transaction).length > 0 ? transaction.id : 0)]);

    //Un presupuesto a afectado NUEVO necesita implicados en el expediente: si no hay, avisamos sin abrir el modal.
    //Uno ya existente sí se abre aunque su afectado haya sido borrado, para poder consultarlo.
    let isNewTransaction = !(transaction && Object.keys(transaction).length > 0);
    if(transactionType == "affected_outgoing_budget" && isNewTransaction){
      let affectedsParams: IParamsCollection = {
        page: { number: 1, size: 1 },
        filter: FilterBuilder.fromObject({ caseId: new Filter(FilterOperation.equals, "caseId", "", this.case.id) }).build()
      };
      let affectedsResponse = await firstValueFrom(this.affectedsService.all(affectedsParams));
      if(affectedsResponse.meta["total"] == 0){
        this.messageService.add({ closable: true, severity: 'info', detail: "No existen implicados en este expediente" });
        return;
      }
    }

    let ref = this.dialogService.open(TransactionsDetailComponent, {
      closable: true,
      header: this.setTitle(transactionType),
      width: '80%',
      draggable: true,
      modal: false,
      data: {
        id: transaction && Object.keys(transaction).length > 0 ? transaction.id : 0,
        transactionType: transactionType,
        caseId: this.case.id
      }
    });

    ref.onClose.subscribe(async () => {
      //Recargamos los presupuestos persistidos antes de evaluar el umbral de siniestro grave.
      await this.loadTransactionsBudget();
      await this.promoteToSeriousSinisterIfBudgetThresholdReached();

      this.loadCase(this.case.id!);
      this.loadTransactionsPurchase();
      if(transactionType == "client_compensation" ) this.loadCompensationTransactions();
    });
  }

  setTitle(transactionType: string){
    switch(transactionType) { 
      case "outgoing_budget":{ 
        return "Presupuesto a cliente";
      } 
      case "outgoing_invoice":{ 
        return "Facturas a clientes"
        break; 
      } 
      case "outgoing_delivery_note":{ 
        return "Albaranes a clientes"
        break; 
      } 
      case "outgoing_order":{ 
        return "Pedido a proveedor";
      } 
      case "company_outgoing_budget": {
        return "Presupuesto a compañía";
      }
      case "incoming_invoice":{ 
        return "Factura de operario";
      } 
      case "purchase_order":{ 
        return "Solicitud de compra";
      } 
      case "ingoing_budget_worker":{ 
        return "Presupuesto de operario";
      } 
      case "affected_outgoing_budget": {
        return "Presupuesto a afectado";
      }
     }
     return "";
  }

  /*async convertToTransacion(convertTo: string, transaction: any){
    let params: IParamsCollection = {
    }
    //creamos filtros
    params.filter = FilterBuilder.fromObject({ code: new Filter(FilterOperation.equals, 'code', '',convertTo) }).build();
    let response = await firstValueFrom(this.transactionsTypesService.all(params));
    let transactionType = response.data[0];

    this.confirmationService.confirm({
      message: "¿Está seguro que desea convertir el presupuesto '" + transaction.code + "' a un "+ transactionType.name +"?",
      header: "Convertir presupuesto",
      acceptLabel: "Aceptar",
      rejectLabel: "Cancelar",
      acceptButtonStyleClass: "p-button-danger",
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
        //Faltara convertir esto... pero es llamar a la edición pero con más información para mostrar todo lo necensario.
        this.editTransaction(convertTo, null, transaction);
      },
      reject: (error: any) => {
      }
    });
  }*/

  async deleteTransactionBudget(transaction: any) {    

    if (this.allowDelete) {
      this.confirmationService.confirm({
        message: "¿Está seguro que desea eliminar el presupuesto " + transaction.code + "?",
        header: "Eliminar presupuesto",
        acceptLabel: "Aceptar",
        rejectLabel: "Cancelar",
        acceptButtonStyleClass: "p-button-danger",
        icon: 'pi pi-exclamation-triangle',
        accept: () => {
          this.transactionsService.delete(transaction.id).subscribe({
            next: (data: any) => {
              this.messageService.add({ closable: true, severity: 'success', detail: "Prosupuesto eliminado correctamente" });
              this.loadTransactionsBudget();
              this.loadTransactionsPurchase();
            },
            error: (error: any) => {
              this.messageService.add({ closable: true, severity: 'error', detail: error.error.title });
            }
          });
        },
        reject: (error: any) => {
          this.messageService.add({ closable: true, severity: 'error', detail: error.error.title });
        }
      });
    }
  }

  async deleteTransactionPurchase(transaction: any) {    

    if (this.allowDelete) {
      this.confirmationService.confirm({
        message: "¿Está seguro que desea eliminar la solicittud de compra " + transaction.code + "?",
        header: "Eliminar solicitud de compra",
        acceptLabel: "Aceptar",
        rejectLabel: "Cancelar",
        acceptButtonStyleClass: "p-button-danger",
        icon: 'pi pi-exclamation-triangle',
        accept: () => {
          this.transactionsService.delete(transaction.id).subscribe({
            next: (data: any) => {
              this.messageService.add({ closable: true, severity: 'success', detail: "Solicitud de compra eliminada correctamente" });
              this.loadTransactionsBudget();
              this.loadTransactionsPurchase();
            },
            error: (error: any) => {
              this.messageService.add({ closable: true, severity: 'error', detail: error.error.title });
            }
          });
        },
        reject: (error: any) => {
          this.messageService.add({ closable: true, severity: 'error', detail: error.error.title });
        }
      });
    }
  }

  async editCaseExpert() {
    let ref = this.dialogService.open(CaseExpertComponent, {
      closable: true,
      header: 'Añadir perito',
      width: '50%',
      draggable: true,
      modal: false,
      data: {
        existentCaseExperts: this.caseExperts,
        caseId: this.case.id
      }
    });

    ref.onClose.subscribe((data: any) => {
      if (data) {
        let caseExpert = new CaseExpert();
        caseExpert.caseId = this.case.id as string;
        caseExpert.expertId = data.id;
        this.casesExpertsService.save(caseExpert).subscribe({
          next: (data: any) => {
            this.messageService.add({ closable: true, severity: 'success', detail: "Perito añadido correctamente." });
            this.loadCaseExperts();
          },
          error: (error: any) => {
            this.messageService.add({ closable: true, severity: 'error', detail: error.error.title });
          }
        });
      }
    });
  }

  async saveCaseExpert(caseExpert:CaseExpert){
    await firstValueFrom(this.casesExpertsService.save(caseExpert));
    this.loadCaseExperts();
  }

  async editCaseTechnical(message: string = "", retry: number = 0) {
    const refTech = this.dialogService.open(CaseTechnicalComponent, {
      closable: true,
      header: 'Añadir técnico',
      width: '60%',
      draggable: true,
      modal: false,
      data: {
        existentCaseTechnicals: this.caseTechnicals,
        caseId: this.case.id,
        message: message
      }
    });

    if(!refTech || !refTech.onClose) {
      if(retry < 3){
        setTimeout(() => {
          this.editCaseTechnical(message, retry + 1);
        }, 150);
      }
      return;
    }

    refTech.onClose.subscribe((data: any) => {
      if (data) {
        let caseTechnical = new CaseUser();
        caseTechnical.caseId = this.case.id as string;
        caseTechnical.userId = data.id;
        this.caseUsersService.save(caseTechnical).subscribe({
          next: async (data: any) => {
            this.messageService.add({ closable: true, severity: 'success', detail: "Técnico añadido correctamente." });
            await this.loadCaseTechnicals(this.lastGridCaseTechnicals);
            await this.validateSeriousSinisterCaseHasTechnicals();
          },
          error: (error: any) => {
            this.messageService.add({ closable: true, severity: 'error', detail: error.error.title });
          }
        });
      } else {
        setTimeout(() => {
          this.validateSeriousSinisterCaseHasTechnicals();
        }, 150);
      }
    });
    

  }

  async editExpert(id: any) {
    let ref = this.dialogService.open(ExpertsDetailComponent, {
      closable: true,
      header: 'Detalles de périto',
      width: '800px',
      draggable: true,
      modal: false,
      data: {
        id: id
      }
    });
    ref.onClose.subscribe((data: any) => {
      this.loadCaseExperts();
    });
  }

  async deleteCaseExpert(id: any) {
    this.confirmationService.confirm({
      message: "¿Está seguro que desea eliminar el perito del expediente?",
      header: "Eliminar perito del expediente",
      acceptLabel: "Aceptar",
      rejectLabel: "Cancelar",
      acceptButtonStyleClass: "p-button-danger",
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
        this.casesExpertsService.delete(id).subscribe({
          next: (data: any) => {
            this.messageService.add({ closable: true, severity: 'success', detail: "Perito eliminado correctamente del expediente." });
            this.loadCaseExperts();
          },
          error: (error: any) => {
            this.messageService.add({ closable: true, severity: 'error', detail: error.error.title });
          }
        });
      }
    });
  }

  async deleteCaseTechnical(id: any) {
    this.confirmationService.confirm({
      message: "¿Está seguro que desea eliminar el técnico del expediente?",
      header: "Eliminar técnico del expediente",
      acceptLabel: "Aceptar",
      rejectLabel: "Cancelar",
      acceptButtonStyleClass: "p-button-danger",
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
        this.caseUsersService.delete(id).subscribe({
          next: async (data: any) => {
            this.messageService.add({ closable: true, severity: 'success', detail: "Técnico eliminado correctamente del expediente." });
            await this.loadCaseTechnicals(this.lastGridCaseTechnicals);
            await this.validateSeriousSinisterCaseHasTechnicals();
          },
          error: (error: any) => {
            this.messageService.add({ closable: true, severity: 'error', detail: error.error.title });
          }
        });
      }
    });
  }

  goToTask(task: Task) {
    window.open(`/tasks/${task.id}`, "_blank");
  }

  async editNote(note: CaseNote | null) {

    if(note == null || this.loginService.hasPermission('CASES.WRITE_ALL_CASE_NOTE') || (note != null && note?.createdByUser?.id==this.currentUser?.id)){
      let ref = this.dialogService.open(CasesDetailNoteComponent, {
        closable: true,
        header: 'Ficha de nota',
        draggable: true,
        width: '700px',
        modal: false,
        data: {
          caseId: this.case.id,
          noteId: note ? note.id : null,
          processorId: this.case.processorId
        }
      });
  
      ref.onClose.subscribe((data: any) => {
        this.loadNotes(this.lastGridCaseNotes);
      });
    }
  }

  async editNoteClient(note: CaseNote | null){
    let ref = this.dialogService.open(NotesClientComponent, {
      closable: true,
      header: (note?.caseNoteType == 'ClientQuestion' ? 'Consulta': 'Reclamación'),
      width: '700px',      
      draggable: true,
      modal: false,
      data: {
        caseId: this.case.id,
        noteId: note ? note.id : null,
        caseNoteType:  (note?.caseNoteType == 'ClientQuestion' ? 'ClientQuestion': 'ClientReclamation'),
        clientId: this.case.clientId,
        editable: false
      }
    });

    ref.onClose.subscribe((data: any) => {
      this.loadNotesClient(this.lastGridCaseNotesClient)
    });
  }

  async deleteNote(id: string) {
    this.confirmationService.confirm({
      message: "¿Está seguro que desea eliminar la nota y la tarea asociada si tiene?",
      header: "Eliminar nota",
      acceptLabel: "Aceptar",
      rejectLabel: "Cancelar",
      acceptButtonStyleClass: "p-button-danger",
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
        this.casesNotesService.delete(id).subscribe({
          next: (data: any) => {
            this.messageService.add({ closable: true, severity: 'success', detail: "Nota eliminada correctamente." });
            this.loadNotes(this.lastGridCaseNotes);
          },
          error: (error: any) => {
            this.messageService.add({ closable: true, severity: 'error', detail: error.error.title });
          }
        });
      },
      reject: (error: any) => {
        this.messageService.add({ closable: true, severity: 'error', detail: error.error.title });
      }
    });
  }

  async editService(service: CaseService | null) {

    if(!this.case.address || !this.case.address?.zipCode || 
      !this.case.address?.city || !this.case.address?.countryRegionId || this.case.caseTypeId == null
    ){
      this.confirmationService.confirm({
        message: "Falta información de la dirección del expediente o el tipo de daño, por favor realiza las correcciones.",
        header: "Es necesario revisar datos",
        acceptLabel: "Aceptar",
        rejectVisible: false,
        icon: 'pi pi-exclamation-triangle',
        accept: () => {       
        },
        reject: (error: any) => {
        }
      });
    }else if(this.distanceToCityCenter == 0){
        this.confirmationService.confirm({
          message: "Distancia al centro de la ciudad no válida, por favor realiza las correcciones.",
          header: "Es necesario revisar datos de la dirección",
          acceptLabel: "Aceptar",
          rejectVisible: false,
          icon: 'pi pi-exclamation-triangle',
          accept: () => {       
          },
          reject: (error: any) => {
          }
        });
    
    }else{
      let ref = this.dialogService.open(CasesDetailServiceComponent, {
        closable: true,
        modal: true,
        header: 'Planificar cita',
        width: '100%',
        height: '100%',
        contentStyle: { 'max-height': '100%', 'overflow': 'auto' },
        
        data: {
          caseId: this.case.id,
          serviceId: service ? service.id : null
        }
      });
      ref.onClose.subscribe((data: any) => {
        this.loadCase(this.case.id!);
        this.loadServices();
      });
    }

    
  }

  async deleteService(id: string) {
    this.confirmationService.confirm({
      message: "¿Está seguro que desea eliminar la cita?",
      header: "Eliminar cita",
      acceptLabel: "Aceptar",
      rejectLabel: "Cancelar",
      acceptButtonStyleClass: "p-button-danger",
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
        this.casesServicesService.delete(id).subscribe({
          next: (data: any) => {
            this.messageService.add({ closable: true, severity: 'success', detail: "Cita eliminada correctamente." });
            this.loadServices();
          },
          error: (error: any) => {
            this.messageService.add({ closable: true, severity: 'error', detail: error.error.title });
          }
        });
      },
      reject: (error: any) => {
        this.messageService.add({ closable: true, severity: 'error', detail: error.error.title });
      }
    });
  }

  async editCaseService(caseService: CaseService | null) {
    let ref = this.dialogService.open(CaseServiceDetailComponent, {
      closable: true,
      header: 'Ficha de cita',
      width: '80%',
      draggable: true,
      modal: false,
      data: {
        caseId: this.case.id,
        caseServiceId: caseService ? caseService.id : null
      }
    });

    ref.onClose.subscribe((data: any) => {
      this.loadCase(this.case.id!);
      this.casesJobsComponent.reload();
      this.loadServices();
    });
  }

  /*
  async onCaseServiceValidated(service:CaseService){
   // service.isValidated = true;
    await firstValueFrom(this.casesServicesService.save(service));
    this.messageService.add({ closable: true, severity: 'success', detail: "Cita validada correctamente." });
    this.loadServices();
  }*/


  getServiceDateTooltip(caseService: CaseService): string {
    let lines: string[] = [];

    if (!caseService.isConfirmed) lines.push("Cita por confirmar");
    if (caseService.notes) lines.push("Instrucciones de trabajos a realizar:\n" + caseService.notes);

    return lines.join("\n\n");
  }


  jobsByWorker(workerId: string) {
    return this.caseJobs.filter((job: Job) => job.workerId == workerId);
  }


  async editCaseFile(caseFile: CaseFile | null) {
    let ref = this.dialogService.open(CasesDetailFileComponent, {
      closable: true,
      header: 'Ficha de archivo',
      width: '800px',
      draggable: true,
      modal: false,
      data: {
        caseId: this.case.id,
        caseFileId: caseFile ? caseFile.id : null
      }
    });

    ref.onClose.subscribe((data: any) => {
      this.loadCaseFiles();
    });
  }

  async printCaseServiceVisitPart(caseService: CaseService) {
    this.casesServicesService.printVisitReport(caseService.id!);
  }

  deleteCaseFile(caseFile: CaseFile) {
    this.confirmationService.confirm({
      message: "¿Está seguro que desea eliminar el archivo?",
      header: "Eliminar archivo",
      acceptLabel: "Aceptar",
      rejectLabel: "Cancelar",
      acceptButtonStyleClass: "p-button-danger",
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
        this.casesFilesService.delete(caseFile.id as string).subscribe({
          next: (data: any) => {
            this.messageService.add({ closable: true, severity: 'success', detail: "Archivo eliminado correctamente." });
            this.loadCaseFiles();
          },
          error: (error: any) => {
            this.messageService.add({ closable: true, severity: 'error', detail: error.error.title });
          }
        });
      }
    });
  }

  toggleCaseFileVisibility(caseFile: CaseFile, field: 'showMobile' | 'showCaseTracking') {
    caseFile[field] = !caseFile[field];
    this.casesFilesService.save(caseFile).subscribe({
      next: () => {
        this.messageService.add({ closable: true, severity: 'success', detail: "Visibilidad del archivo actualizada." });
        this.loadCaseFiles();
      },
      error: (error: any) => {
        caseFile[field] = !caseFile[field]; //revertir el cambio local si falla el guardado
        this.messageService.add({ closable: true, severity: 'error', detail: error.error.title });
      }
    });
  }

  filesByService(serviceId: string) {
    return this.caseFiles.filter((caseFile: any) => caseFile.caseServiceId == serviceId);
  }

  fileIsAnImage(file: File) {
    return file.contentType.startsWith("image");
  }

  downloadFile(fileId: string) {
    //la descarga no deja rastro en base de datos, así que la registra la interfaz
    this.auditService.track(AuditEvents.ATTACHMENT_DOWNLOAD, {
      entityType: 'file',
      entityId: fileId
    });

    this.filesService.download(fileId);
  }

  async openChat(service: CaseService) {
    let titleParts: string[] = [];
    if (service.case) titleParts.push(service.case.caseNumber);
    let datePipe = new DatePipe('es-ES');
    titleParts.push('Cita ' + datePipe.transform(service.date, 'dd/MM/yyyy')!);
    if (service.worker) titleParts.push(service.worker.name);
    let title = titleParts.join(" - ");
    this.chatService.openChatCaseService(service, title);
  }

  async loadLogs($event: any){
    this.lastGridLogEvent = $event;

    //si no esta abierta la pestaña de logs, no cargamos nada
    if(!this.accordionTabs.tabs[1].selected) return;

    //sin expediente cargado no consultamos: si se aplica el filtro de mensaje sin caseId, el FilterBuilder omite
    //el caseId vacio y la consulta se convierte en un LIKE '%x%' global sobre cases_logs (~9M filas / 8,9 GB, 76-240s).
    if(!this.case?.id) return;

    let pendingFilters: any = {};
    this.loadingLogs = true;
    this.caseLogsFilter.caseId= new Filter(FilterOperation.equals, 'caseId', "", this.case.id);
    if(this.pendingLogs){      
      pendingFilters = {
        caseId: new Filter(FilterOperation.equals, "caseId", "", this.case.id),
        direction: new Filter(FilterOperation.equals, "direction", '', "In"),
        caseLogTypeId: new NotFilter(FilterOperation.equals, "caseLogTypeId", '', null, true),            
        completedAt: new Filter(FilterOperation.equals, 'completedAt', '', null, true)
      }      
    }    
    if(this.changeStates){
      this.caseLogsFilter.message = new Filter(FilterOperation.contains, 'message', '', 'Estado cambiado');
    }else{
      delete this.caseLogsFilter.message;
    }
    let params: IParamsCollection = {
      sort: ['-date'],
      include: ['createdByUser', 'caseLogType', 'completedByUser', 'integrationEvent', 'caseLogFiles'],
      filter: FilterBuilder.fromObject(this.pendingLogs?pendingFilters:this.caseLogsFilter).build(),
      page: { number: this.lastGridLogEvent.first + 1, size: this.lastGridLogEvent.rows },
      fields: {
        users: ['id', 'name'],
        caseLogFiles: ['id', 'fileId'],
      }
    }
    if (typeof this.lastGridLogEvent.sortField != "undefined") params.sort = [(this.lastGridLogEvent.sortOrder > 0 ? "-" : "") + this.lastGridLogEvent.sortField];

    let response = await firstValueFrom(this.casesLogsService.all(params));
    this.caseLogs = response.data;
    this.totalLogsRecords = response.meta['total'];
    this.loadingLogs = false;
    this.countLogs = this.totalLogsRecords;
  }

  async addEvent(){
    let ref = this.dialogService.open(CaseLogDetailComponent, {
      closable: true,
      header: 'Nueva comunicación',
      width: '400px',
      draggable: true,
      modal: false,
      data: {
        caseId: this.case.id,
        contractId: this.case.contractId
      }
    });

    ref.onClose.subscribe((data: any) => {
      this.loadLogs(this.lastGridLogEvent);
      this.loadCase(this.case.id!); //actualizamos el case porque cambia si ponen uno manual y luego cambian la fehca de revisión.

      //solo registramos si realmente se ha creado el evento, no si se ha cerrado el diálogo
      if (data != null) {
        this.auditService.track(AuditEvents.APPOINTMENT_EVENT_CREATE, {
          entityType: 'caseLog',
          entityId: data.id,
          metadata: { eventType: data.caseLogType?.name ?? data.caseLogTypeId }
        });
      }
    });
  }

  addComunication($event:any, comunicationType:string|null, email:string|null, phoneNumber:string|null, attachment: boolean = false) {
    $event?.stopPropagation();
    let comunicationModel:any = this.case;
    comunicationModel.caseService = this.phoneOverlayPanelData.caseService ?? this.getTemplateCaseService();
    let ref = this.dialogService.open(ComunicationsComponent, {
      closable: true,
      header: 'Enviar comunicación',
      width: '60%',
      draggable: true,
      modal: false,
      data: {
        caseId: this.case.id,
        model: comunicationModel,
        comunicationType: comunicationType,
        email: email,
        phoneNumber: phoneNumber,
        templateDestination: 'Case',
        attachments: (attachment ? this.filesIdsToSend: [])
      }
    });

    ref.onClose.subscribe((data: any) => {
      this.loadLogs(this.lastGridLogEvent);
    });
  }

  getTemplateCaseService(): CaseService|undefined {
    let orderedServices: CaseService[] = this.caseServices.sort((a: CaseService, b: CaseService) => {
      return a.date.getTime() - b.date.getTime();
    });

    return orderedServices.find(service => service.date >= new Date()) ?? orderedServices.at(-1);
  }

  showPhoneOverlayPanel($event:any, phoneNumber:string|undefined, callerId:string|undefined, caseService:CaseService|undefined = undefined){
    //si no hay caseService, usamos el mas reciente para no dejar el sms/mail sin fecha de cita
    if(caseService == undefined){
      caseService = this.getTemplateCaseService();
    }

    this.phoneOverlayPanelData.caseService = caseService;
    this.phoneOverlayPanelData.phoneNumber = phoneNumber;
    this.phoneOverlayPanelData.callerId = callerId;
    this.phoneOverlayPanel?.show($event);
  }

  openWhatsapp(caseId:string|null = null, phoneNumber:string, name:string|null){
    //abrimos dialogo de whatsapp
    let ref = this.dialogService.open(WhatsAppChatComponent, {
      closable: true,
      header: 'Whatsapp ' + phoneNumber + (name ? ' - ' + name : ''),
      width: '800px',
      draggable: true,
      modal: false,
      data: {
        caseId: caseId,
        phoneNumber: phoneNumber,
        name: name
      }
    });
    ref.onClose.subscribe((data: any) => {
      //nothing to do
    });
  }

  getContentBetweenBrackets(text: string): string | string {
    const match = text.match(/<([^>]+)>/);
    return match ? match[1] : text;
  }
  
  mail(email:string|undefined, caseId:string|null = null, caseServiceId:string|null = null, attachment: boolean = false){
    if(email){
      email = this.getContentBetweenBrackets(email); //por si llega con el formato "Nombre <email>"
      this.addComunication(null, 'Mail', email, null, attachment);
    }
  }

  sms(phoneNumber:string|undefined, caseId:string|null = null, caseServiceId:string|null = null){
    if(phoneNumber){
     this.addComunication(null, 'SMS', null, phoneNumber);
     this.phoneOverlayPanel?.hide();
    }
  }

  whatsapp(phoneNumber:string|undefined, caseId:string|null = null, callerId:string|null = null){
    if(phoneNumber){
     this.openWhatsapp(caseId, phoneNumber, callerId);
     this.phoneOverlayPanel?.hide();
    }
  }

  call(phoneNumber:string|undefined, callerId:string|null = null, caseId:string|null = null, caseServiceId:string|null = null){
     if(phoneNumber){
      this.phoneService.call(phoneNumber!, callerId, true, caseId, caseServiceId);
      this.phoneOverlayPanel?.hide();
     }
  }


  async editClientPolicy(clientPolicyId: string) {  
      let ref = this.dialogService.open(ClientPolicyComponent, {
        closable: true,
        header: 'Ficha póliza',
        width: '900px',
      draggable: true,
      modal: false,
        data: {
          id: clientPolicyId          
        }
      });
  
      ref.onClose.subscribe(async (data: ClientPolicy) => {    
        if (data != null) {
          this.loadCase(this.case.id!);          
        }
      });  
    }

    showModal() {                      
      this.displayModal = true;      
    }
  
    async hideModal() {      
      await firstValueFrom(this.casesService.save(this.case));
      await this.loadCase(this.case.id!);
      await this.loadCaseStates();
      this.casesJobsComponent.reload();//para que si está abierto, se recarge los valores del this.case
      this.displayModal = false;
    }

    async cancelHideModal(){
      await firstValueFrom(this.casesService.save(this.case));
      await this.loadCase(this.case.id!);
      await this.loadCaseStates();
      this.casesJobsComponent.reload();//para que si está abierto, se recarge los valores del this.case
      this.displayModal = false;            
    }
    
    async readNotifications(){
      this.notifications.forEach((notification: any) => {
        firstValueFrom(this.notificationsService.markAsReaded(notification));
      });            

      this.showNotifications = false;
    }

    async changeCaseStatusModal($event:any, data: Case, isFinal: boolean = true, selectedCaseStateId: string|null = null){
      $event?.stopPropagation();

      let ref = this.dialogService.open(CaseStateChangeComponent, {
        closable: true,
        header:  (isFinal ? 'Cerrar expediente' : 'Cambiar estado'),
        width: '500px',
        draggable: true,
        modal: false,
        data: {
          id: this.case.id,
          isFinal: isFinal,
          selectedCaseStateId: selectedCaseStateId,
          caseModeCode: this.caseModeCode
        }
      });

      ref.onClose.subscribe((data: any) => {
        this.loadCase(this.case.id as string);

        //ITSM #1838992: si el cierre se ha redirigido automáticamente a "Rev económica" por rentabilidad
        //insuficiente, la fecha de revisión ya se ha puesto a hoy sin intervención del usuario: no
        //mostramos el popup de selección de fecha de revisión.
        if(!data?.skipRevisionDateModal){
          //mostramos modal de fecha de revisión
          this.showModal();
        }
      });
    }

    //ITSM #1838992: marca como revisada la rentabilidad del expediente (permiso CASES.PROFIT_REVIEW) y lo
    //pasa a "Gestión Factura" para que pueda finalizarse aunque su rentabilidad siga por debajo del
    //mínimo del contrato. El backend (CaseChangeTracking) valida de nuevo el permiso y hace el cambio de
    //estado real; aquí solo se dispara el guardado.
    async acknowledgeProfitReview($event:any){
      $event?.stopPropagation();

      this.case.profitReviewAcknowledged = true;
      this.case.revisionDate = new Date();

      await firstValueFrom(this.casesService.save(this.case));
      this.messageService.add({severity:'success', summary: 'Éxito', detail: 'Revisión de rentabilidad marcada como realizada. El expediente ha pasado a "Gestión Factura".'});
      this.loadCase(this.case.id as string);
    }

    async openGenerali($event:any){
      $event?.stopPropagation();

      if(this.frmGenerali){
        if(!this.frmGeneraliEventsAttached){
          this.frmGenerali.nativeElement.onload = async () => {
            let response:any = await firstValueFrom(this.generaliService.OpenWeb(this.case.id!));
            if(response.success){
              window.open(response.url, '_blank');
            }else{
              this.messageService.add({ severity: 'error', summary: 'Error', detail: response.message });
            }
            this.frmGenerali?.nativeElement.removeAttribute("src");
          };
          this.frmGeneraliEventsAttached = true;
        }
        this.frmGenerali.nativeElement.setAttribute("src", "https://www.generali.es/gpf3k/arq_genernetPortalFormWeb/logoutPortal.po");
      }
    }

    async openMulti($event:any, serviceNumber:string){
      $event?.stopPropagation();
      await this.multiService.openCase(this.case.id!, serviceNumber);
    }

    getRecordingUrl(recording:Recording):string {
      let url = this.recordingService.getDownloadUrl(recording);
      return url;
    }

    async resumeCase($event:any, oCase:Case){
      $event?.stopPropagation();
      let ref = this.dialogService.open(CaseResumeComponent, {
        closable: true,
        header: 'Resumen de expediente',
        width: '800px',
        draggable: true,
        modal: false,
        data: {
          id: oCase.id
        }
      });
      ref.onClose.subscribe((data: any) => {
        this.loadHasCaseResume(oCase.id as string);

        //el resumen se genera desde la interfaz y no pasa por ningún ChangeTracking
        this.auditService.track(AuditEvents.CASE_RESUME_GENERATE, {
          caseId: oCase.id,
          entityType: 'case',
          entityId: oCase.id
        });
      });
    }

    openCaseVideoModal($event: any, oCase: Case) {
        $event?.stopPropagation();
        let ref = this.dialogService.open(CaseAgentFlowSessionComponent, {
            closable: true,
            header: 'Videoperitaciones',
            width: '900px',
            draggable: true,
            modal: false,
            data: {
                id: oCase.id
            }
        });

        //al cerrar el popup puede haber llegado un informe nuevo: refrescamos el color del botón
        ref.onClose.subscribe(() => this.loadHasCaseAgentInforme(oCase.id as string));
    }

    async transcribeRecording(recording:Recording){
      let result = await firstValueFrom(this.recordingService.transcribe(recording));
      recording.transcription = result.transcription;
    }

    /**
     * Resuelve la grabación de una entrada CALL del timeline. Con el nuevo modelo, resourceId es el
     * Id de communications.calls; para CaseLog históricos aún sin backfill, resourceId es el guid del cdr.
     * Devuelve el uniqueId de la grabación y el tiempo de conversación, o null si no se encuentra.
     */
    private async resolveCallRecordingInfo(resourceId:string): Promise<{ uniqueId: string, talkSec: number } | null> {
      //1) modelo nuevo: la entrada CALL apunta a communications.calls por Id
      let callFilter = { id: new Filter(FilterOperation.equals, 'id', '', resourceId) };
      let callParams: IParamsCollection = { filter: FilterBuilder.fromObject(callFilter).build() };
      let callResponse = await firstValueFrom(this.callService.all(callParams));
      if(callResponse.data.length > 0){
        let call = callResponse.data[0];
        return { uniqueId: call.recordingRef ?? '', talkSec: call.talkSec ?? 0 };
      }

      //2) histórico: la entrada CALL apunta al cdr por guid
      let cdrFilter = { guid: new Filter(FilterOperation.equals, 'guid', '', resourceId) };
      let cdrParams: IParamsCollection = { filter: FilterBuilder.fromObject(cdrFilter).build() };
      let cdrResponse = await firstValueFrom(this.cdrService.all(cdrParams));
      if(cdrResponse.data.length > 0){
        let cdr = cdrResponse.data[0];
        return { uniqueId: cdr.uniqueId, talkSec: cdr.billSec };
      }

      return null;
    }

    async showRecordingTranscription(resourceId:string){
      let info = await this.resolveCallRecordingInfo(resourceId);
      if(info == null || !info.uniqueId){
        this.messageService.add({ severity: 'error', detail: 'Llamada no encontrada'});
        return;
      }

      //buscamos la grabacion
      let filterRecording = {
        UniqueId: new Filter(FilterOperation.equals, 'uniqueId', '', info.uniqueId)
      }
      let paramsRecording: IParamsCollection = {
        filter: FilterBuilder.fromObject(filterRecording).build()
      }
      let responseRecordings = await firstValueFrom(this.recordingService.all(paramsRecording));
      if(responseRecordings.data.length>0){
        let recording:Recording = responseRecordings.data[0];
        var ref = this.dialogService.open(RecordingDetailComponent, {
          closable: true,
          header: 'Transcripción de grabación',
          width: '600px',
          draggable: true,
          modal: false,
          data: {
            id: recording.id
          }
        });
        ref.onClose.subscribe((data: any) => {
          //nothing to do
        });
      }else{
        this.messageService.add({ severity: 'error', detail: 'Grabación no encontrada'});
      }

    }

    async showInfoAssignProcessor(caseLog: any){
      caseLog.show = (caseLog.show ? !caseLog.show : true);
    }

    async showResourceInfoFromLog(caseLog: CaseLog){
      
      //comprobamos si ya está abierto, si está abierto, lo cerramos. 
      if(this.resourceCaseLog[caseLog.resourceId]){
        this.resourceCaseLog[caseLog.resourceId] = null;
      }else{
        if(caseLog.resourceId != null && caseLog.resourceType != CaseLogResourceType.Chat){

          //Buscamos dependiendo del resourceType
          if(caseLog.resourceType == CaseLogResourceType.Mail){
            var message =  await firstValueFrom(this.mailMessageService.get(caseLog.resourceId, {include: ['mailAccount', 'recipients', 'attachments.file']}));
            let filters = {
              mailMessageId: new Filter(FilterOperation.equals, 'mailMessageId', '', caseLog.resourceId)
            }      
            let params: IParamsCollection = {
              filter: FilterBuilder.fromObject(filters).build()
            }
        
            let receipts = await firstValueFrom(this.mailMessageRecipientService.all(params));
  
            this.resourceCaseLog[caseLog.resourceId] = {
                message: message, 
                stateDate: moment(message.stateDate).format("DD/MM/YYYY HH:mm"),
                receipts: receipts.data.filter(m => m.recipientType=='To').map(m => m.mailAddress).join(', ')};
  
             //esablecemos html al iframe
             setTimeout(() => {
              var iframe: any = document.getElementById("mail-preview-iframe-"+caseLog.resourceId);
              var contentDocument: any = iframe?.contentDocument;
              if (contentDocument != null) {
                contentDocument.open();
                contentDocument.write(message.content);
                contentDocument.close();
              }
            });
          }else if(caseLog.resourceType == CaseLogResourceType.Call){
            if(this.allowRecordingAccess){
              //resolvemos la llamada (por Call.Id nuevo, o cdr.guid histórico)
              let info = await this.resolveCallRecordingInfo(caseLog.resourceId);
              if(info == null || !info.uniqueId){
                return;
              }

              //buscamos la grabacion
              let filterRecording = {
                UniqueId: new Filter(FilterOperation.equals, 'uniqueId', '', info.uniqueId)
              }
              let paramsRecording: IParamsCollection = {
                filter: FilterBuilder.fromObject(filterRecording).build()
              }
              let responseRecordings = await firstValueFrom(this.recordingService.all(paramsRecording));
              if(responseRecordings.data.length>0){
                let recording:Recording = responseRecordings.data[0];
                this.resourceCaseLog[caseLog.resourceId] = { call: { talkSec: info.talkSec }, recording: recording };
              }
            }
          }else if(caseLog.resourceType == CaseLogResourceType.Incident){

            var incident =  await firstValueFrom(this.caseIncidentsService.get(caseLog.resourceId, {include: ['thirdParty', 'incidentType']}));
  
            this.resourceCaseLog[caseLog.resourceId] = {
                message: incident.description, 
                date: moment(incident.date).format("DD/MM/YYYY HH:mm")
            }
            
          }
        }
      }      
    }

    getMailBody(mailMessage:MailMessage){     
      var doc = new DOMParser().parseFromString(mailMessage.content, 'text/html');
      return doc.body.innerHTML || "Sin contenido";
    }

    async changeProcessor(){
      let selectedProcessor = this.processors.find((processor: any) => processor.id == this.case.processorId);
      if(!selectedProcessor) return;

      await firstValueFrom(this.casesService.save(this.case));
      this.loadCase(this.case.id as string);
    }

    getSelectedProcessor() {
      return this.processors.find((processor: any) => processor.id == this.case.processorId);
    }

    async changeCaseState() {
      //obtenemos el estado seleccionado
      let selectedState = this.caseStates.find((state: any) => state.id == this.case.caseStateId);
      if(!selectedState) return;

      let showCaseStatusModal:boolean = false;
      
      //si estaba cerrado y se esta abriendo
      if(this.originalCaseState?.isFinal && !selectedState?.isFinal){
        showCaseStatusModal = true;
      }

      //si el estado tiene configuracion
      if(selectedState.configuration != null && selectedState.configuration != "") showCaseStatusModal = true;

      //mostramos el modal de cambio de estado para que rellene los campos necesarios o bien cambiamos directamente
      if(showCaseStatusModal){
        this.changeCaseStatusModal(null, this.case, false, selectedState.id);
      }else{
        const requestedStateId = selectedState.id;
        const savedCase = await firstValueFrom(this.casesService.save(this.case));
        await this.loadCase(this.case.id as string);
        this.loadCaseStates();

        //ITSM #1838992: si el backend ha redirigido el guardado a "Rev económica" por rentabilidad
        //insuficiente al intentar finalizar, la fecha de revisión ya se ha puesto a hoy automáticamente:
        //no mostramos el popup de selección de fecha de revisión, avisamos con un toast en su lugar.
        if(savedCase?.caseStateId && savedCase.caseStateId !== requestedStateId){
          this.messageService.add({severity:'warn', summary: 'Rentabilidad menor a la permitida', detail: 'El expediente ha pasado a "Rev económica" para su revisión antes de poder finalizarse.'});
        }else{
          //mostramos modal de fecha de revisión
          this.showModal();
        }
      }
    }
    
    getSelectedCaseState(){
      return this.caseStates.find((state: any) => state.id == this.case.caseStateId);
    }

    async exportTransaction(transactionType: string, transactionId: string){
      this.templateService.getTemplateId(transactionType, this.case?.contractId, this.case?.companyId, undefined, this.case?.id).then((result:any) => {
        if(result != null){
          this.transactionsService.export(transactionId, result.templateId, result.metadata);
        }
      });
    }

    async displayModalPhoto(){
      let ref = this.dialogService.open(PhotoReportComponent, {
        closable: true,
        header: 'Reporte fotográfico',
        width: '70%',
        modal: false,
        data: {
          case: this.case,
          caseServices: this.caseServices,
          caseFilesServices: this.caseFilesServices,
          //el informe fotografico sigue tratando los del asegurado como generales: alli no hay carpetas
          caseFilesWithoutService: this.caseFilesWithoutService.concat(this.caseFilesInsured),
          caseFiles: this.caseFiles
        }
      });
  
      ref.onClose.subscribe((data: any) => {
        this.loadLogs(this.lastGridLogEvent);
      });
    }

    

    async caseLogCompleted(event: any,caseLog:CaseLog){        
      caseLog.completedAt = event.checked ? new Date() : null;
      caseLog.completedById = event.checked ? this.storage.get('user').id:null;
      await this.casesLogsService.save(caseLog).subscribe({
        next: (data) => {
          this.messageService.add({ severity: 'success', summary: 'Éxito', detail: 'Comunicación completada correctamente' });
          this.loadLogs(this.lastGridLogEvent);
          this.loadPendingLogs(this.case.id!, false)
        },
        error: (error) => {
          this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Error al guardar la especialidad' });
        }
      });

  }

  getWorkersSummary() {

    const totalCompanyJobs = this.jobs.reduce((sum:any, job:any) => sum + (job.isForCompany?(job.subtotal):0), 0);    
    let totalWorkerJobs = this.jobs.reduce((sum:any, job:any) => sum + (!job.isForCompany && job.providerId == null?(job.subtotal):0), 0); //los del trabajador, no del proveedor.

    const subtotalMaterials = this.jobs.reduce((sum:any, job:any) => sum + (!job.isForCompany && job.providerId != null ? (job.subtotal) : 0), 0); //los del proveedor     
    //Ticket #567 MARIVEL solicita que las solicitudes de compra se usen con el subtotal para los beneficios!!!!
    //const totalPurchases = this.caseTransactionsPurchase.reduce((sum:any, transaction:any) => sum + transaction.subtotal, 0);
    //const totalWorkerInvoices = this.caseTransactionsWorkerInvoice.reduce((sum:any, transaction:any) => sum + transaction.subtotal, 0);
    const totalDevClient =  this.compensationTransactions.reduce((sum:any, transaction:any) => sum + transaction.subtotal, 0);

    //totalWorkerJobs += totalWorkerInvoices; //los trabajos del operario ya lleva la factura de operario, no hay que volverlas a sumar aqui, sino no salen las cuentas bien. BELEN.
    //beneficio = trabajos a compañia - solicitudes compras - trabajos de operario - devoluciones economicas
    //const totalProfit = totalCompanyJobs - totalPurchases - totalWorkerJobs - totalDevClient;
    const totalProfit = totalCompanyJobs - subtotalMaterials - totalWorkerJobs - totalDevClient;
    const totalProfitPercent = totalCompanyJobs > 0 ? (totalProfit * 100) / totalCompanyJobs : 0;
  
    return {
      totalCompanyJobs,
      totalWorkerJobs,
      subtotalMaterials,
      totalProfit,
      totalProfitPercent,
      totalDevClient
    };
  }

  async loadCaseIncidents($event: any){
    
    this.lastGridCaseIncident = $event;
    //si no esta abierta la pestaña de logs, no cargamos nada
    if(!this.accordionTabs?.tabs[11].selected) return;

    this.loadingCaseIncident = true;
    let params: IParamsCollection = {
      sort: ['date'],
      page: { number: this.lastGridCaseIncident.first + 1, size: this.lastGridCaseIncident.rows }
    }
    let filters: any = {
      caseId: new Filter(FilterOperation.equals, "caseId"),
    };
    if (typeof this.lastGridCaseIncident.sortField != "undefined") params.sort = [(this.lastGridCaseIncident.sortOrder > 0 ? "-" : "") + this.lastGridCaseIncident.sortField];

    filters.caseId.value = this.case.id;
    params.filter = FilterBuilder.fromObject(filters).build();
    params.include = ['thirdParty', 'incidentType'];

    let response = await firstValueFrom(this.caseIncidentsService.all(params));
    this.caseIncidents = response.data;
    this.totalCaseIncidentsRecords = response.meta['total'];
    this.loadingCaseIncident = false;
    this.countIncidents = this.totalCaseIncidentsRecords;
  }
  
  editCaseIncidentClient(incident?: CaseIncident){
    let ref = this.dialogService.open(IncidentsComponent, {
      closable: true,
      header: 'Ficha de incidente',
      width: '30%',
      draggable: true,
      modal: false,
      data: {
        caseId: this.case.id,
        case: this.case,
        id: (incident ? incident.id : null),
        caseServicesWorkersIds: this.caseServices.map((service: CaseService) => service.workerId)
      }
    });

    ref.onClose.subscribe((data: any) => {
      this.loadCaseIncidents(this.lastGridCaseIncident);
    });
  }


  invoice(){
    let ref = this.dialogService.open(JobsPendingInvoiceComponent, {
      closable: true,
      header: 'Trabajos pendientes de facturar',
      width: '1024',
      draggable: true,
      modal: false,
      data: {
        caseId: this.case.id,
        invoiceMode: this.case.contract?.invoiceMode,
        invoiceDiscount: this.case.contract?.invoiceDiscount,
        invoiceRetentionPercent: this.case.contract?.invoiceRetentionPercent,
        invoiceRetentionDays: this.case.contract?.invoiceRetentionDays,
        paymentMethodId: this.case.contract?.paymentMethodId,
        billingCompanyBankAccountId: this.case.contract?.billingCompanyBankAccountId,
        paymentDuedateDays:  this.case.contract?.paymentDuedateDays, 
   
        businessId: this.case.contract?.billingCompanyId,
      }
    });

    ref.onClose.subscribe((data: any) => {      
      this.loadCaseIncidents(this.lastGridCaseIncident);
      this.casesJobsComponent?.reload();
      this.loadCase(this.case.id as string);
    });
  }
  

  async loadCompensationTransactions() {
    this.loadingCompensationTransactions = true;
    let params: IParamsCollection = {
      include: ['transactionState', 'thirdParty', 'transactionType', 'relatedTransaction']
    }
    let filters: any = {
      caseId: new Filter(FilterOperation.equals, "caseId"),
      transactionTypeCode: new Filter(FilterOperation.any, "transactionType.code", '', "client_compensation")
    };
    filters.caseId.value = this.case.id;    
    params.filter = FilterBuilder.fromObject(filters).build();
    
    let response = await firstValueFrom(this.transactionsService.all(params));
    this.compensationTransactions = response.data;        
    this.totalCompensationTransactionsRecords = response.meta['total'];
    this.loadingCompensationTransactions = false;
    this.countCompensationTransactions  = this.totalCompensationTransactionsRecords;
  }

  async deleteCompensationTransaction(transaction: any) {    

    if (this.allowDelete) {
      this.confirmationService.confirm({
        message: "¿Está seguro que desea eliminar la devolución " + transaction.code + "?",
        header: "Eliminar devolución",
        acceptLabel: "Aceptar",
        rejectLabel: "Cancelar",
        acceptButtonStyleClass: "p-button-danger",
        icon: 'pi pi-exclamation-triangle',
        accept: () => {
          this.transactionsService.delete(transaction.id).subscribe({
            next: (data: any) => {
              this.messageService.add({ closable: true, severity: 'success', detail: "Devolución eliminada correctamente" });
              this.loadCompensationTransactions();
            },
            error: (error: any) => {
              this.messageService.add({ closable: true, severity: 'error', detail: error.error.title });
            }
          });
        },
        reject: (error: any) => {
          this.messageService.add({ closable: true, severity: 'error', detail: error.error.title });
        }
      });
    }
  }

  async saveServiceTypeCase(event: any) {
   
    this.casesService.updateCaseServiceTypes(this.case.id as string, event.checked).subscribe({
      next: (data: any) => {
       // this.messageService.add({ closable: true, severity: 'success', detail: "Tipo de servicio añadido correctamente." });
       // this.loadCase(this.case.id!);
      },
      error: (error: any) => {
        this.messageService.add({ closable: true, severity: 'error', detail: error.error.title });
      }
    });

  }

  async generateCompensation() {

    //si el tercero no tiene cif no dejamos generarla
    if(this.case.client?.vatNumber == null || this.case.client?.vatNumber.trim() == ""){
      this.messageService.add({
        severity: 'error',
        summary: 'Error',
        detail: 'No se puede generar una indemnización a un cliente sin CIF/NIF.'
      });
      return;
    }

    await this.loadTaxes();  
    await this.loadClientBankAccounts()

    let params: IParamsCollection = {            
    }        
    //creamos filtros
    params.filter = FilterBuilder.fromObject({code: new Filter(FilterOperation.equals, 'code', '', 'client_compensation')}).build();

    let response = await firstValueFrom(this.transactionsTypesService.all(params));    
    let transactionType = response.data[0]; 
        
    this.compensation.taxPercent = this.taxes.filter(m => m.code == "GENERAL")[0].percent;


    this.displayCompensationModal = true;
    this.compensation.date = new Date();
    this.compensation.transactionTypeId = transactionType.id;
    this.compensation.caseId = this.case.id;
    this.compensation.price = this.compensation.subtotal;
    this.compensation.total = this.compensation.total;           
    
    this.calculatePrices();

  }

  async saveCompensation(){    
    
    //Comprobar hay cuenta bancaria seleccionada
    if(this.compensation.clientBankAccountId == null){
      this.messageService.add({
        severity: 'error',
        summary: 'Error',
        detail: 'Debe seleccionar una cuenta bancaria.'
      });
      return;
    }

    if(this.compensation.price == null || this.compensation.price == 0){
      this.messageService.add({
        severity: 'error',
        summary: 'Error',
        detail: 'El importe de la indeminzación debe ser mayor a 0.'
      });
      return;
    }

    let result: any = await firstValueFrom(this.transactionsService.generateClientCompensation(this.compensation));

    this.messageService.add({ closable: true, severity: 'success', summary: 'Abono guardado correctamente.' });
    this.displayCompensationModal = false;
    
    this.loadCompensationTransactions();
  }

  async loadClientBankAccounts() {
    //Traemos las cuentas bancarias del cliente
    this.loadingClientBankAccounts = true;
    if(this.case.client?.bankAccountId != null){
      let clientBankAccount = await firstValueFrom(this.clientBankAccountsService.get(this.case.client?.bankAccountId));        
      this.clientBankAccounts = [clientBankAccount];      
      this.compensation.clientBankAccountId = clientBankAccount.id;
    }
    this.loadingClientBankAccounts = false;
    
  }

  async loadTaxes() {
    this.loadingTaxes = true;
    let params: IParamsCollection = {
    }

    let response = await firstValueFrom(this.taxesService.all(params));
    this.taxes = response.data;

    this.loadingTaxes = false;
  }

  calculatePrices() {
    const price = this.compensation?.price || 0;
    const taxPercent = this.compensation?.taxPercent || 0;
  
    // Cálculo del importe de impuestos
    this.compensation.taxAmount = price * (taxPercent / 100);
  
    // Cálculo del subtotal final con impuestos
    this.compensation.subtotal = price;
    this.compensation.total = price + this.compensation.taxAmount;
  }


  getDeclarationInfo(declaration:any){     
    if(typeof declaration == "undefined"||declaration==null) return "No se ha registrado ninguna declaración de siniestro";
    var doc = new DOMParser().parseFromString(declaration, 'text/html');
    return doc.body.innerHTML || "No se ha registrado ninguna declaración de siniestro";
  }

  getIntegrationEventFiles(integrationEvent:IntegrationEvent){
    if(integrationEvent && integrationEvent.data){
      let data = JSON.parse(integrationEvent.data);
      if(data.files && data.files.length>0){
        return data.files;
      }
    }
    return [];
  }

  async editCaseNotificationNumber($event: any){
    this.caseNotificationNumber = $event;
    this.displayCaseNotificationNumberModal = true;
  }

  async updateCaseNotificationNumber(){
    if(this.case.id==null) return;
    let response = await firstValueFrom(this.casesService.updateNotificationNumbers(this.case.id!));
    if(!response.success){
      this.messageService.add({ closable: true, severity: 'error', detail: response.message });
    }else{
      this.messageService.add({ closable: true, severity: 'success', detail: 'Números de servicios actualizados correctamente.' });
      this.loadCaseNotificationsNumbers();
    }
  }

  async saveCaseNotificationNumber(){

    var aux = new CaseNotificationNumber();
    if(this.caseNotificationNumber.id!=null) aux.id = this.caseNotificationNumber.id;
    aux.caseId = this.case.id as string;
    aux.code = this.caseNotificationNumber.code;
    aux.description = this.caseNotificationNumber.description;
    aux.date = this.caseNotificationNumber.date;
    aux.state = this.caseNotificationNumber.state;
    aux.capabilityDescription = this.caseNotificationNumber.capabilityDescription;

    if(aux.code == null || aux.code.trim() == ""){

        this.messageService.add({ closable: true, severity: 'error', detail: 'El código es obligatorio.' });
    }else{
       /*this.caseNotificationNumber.caseId = this.case.id as string;
      delete this.caseNotificationNumber.displayInfo;*/
    
      await firstValueFrom(this.caseNotificationsNumbersService.save(aux));  
      this.loadCaseNotificationsNumbers();
      this.displayCaseNotificationNumberModal = false;
      this.caseNotificationNumber = new CaseNotificationNumber();
    }

     
  }
  
  isOnTime(service:CaseService):boolean{
    let now = new Date();
    return !service.isFailed && !service.isCancelled && service.workerAttendanceStatus!='rejected' && service.workerAttendanceStatus!='rejected_day' && service.date>now;
  }

  isTooLate(service:CaseService):boolean{
    let now = new Date();
    return !service.isFailed && !service.isCancelled && service.workerAttendanceStatus!='rejected' && service.workerAttendanceStatus!='rejected_day' && service.date<now && service.dateStart==null;
  }

  isStarted(service:CaseService):boolean{
    return !service.isFailed && !service.isCancelled && service.workerAttendanceStatus!='rejected' && service.workerAttendanceStatus!='rejected_day' && service.dateStart!=null && service.dateEnd==null;
  }

  isEnded(service:CaseService):boolean{
    return !service.isFailed && !service.isCancelled && service.workerAttendanceStatus!='rejected' && service.workerAttendanceStatus!='rejected_day' && service.dateStart!=null && service.dateEnd!=null;
  }

  isRejected(service:CaseService):boolean{
    return service.workerAttendanceStatus=='rejected' || service.workerAttendanceStatus=='rejected_day';
  }

  isFailed(service:CaseService):boolean{
    return service.isFailed && service.workerAttendanceStatus!='rejected' && service.workerAttendanceStatus!='rejected_day';
  }

  isCancelled(service:CaseService):boolean{
    return service.isCancelled;
  }

  generateZIP(caseServiceId?: string){
    this.casesService.exportCasePhotosZIP(this.case.id!, "Expediente:_"+this.case.caseNumber, caseServiceId);
  }
/*
  getTooltipImage(image: any): string {
    return `<img src="${this.imagesUrl + image.fileId + '/download'}" style="height: 600px; max-width: 500px;border-radius: 5px;"/>`;
  }*/


    /******* MEDIADORES  *******/


    async loadCaseMediators($event?: any) {

      this.lastGridCaseMediators = $event;
      //si no esta abierta la pestaña de logs, no cargamos nada
      //if(!this.accordionTabs?.tabs[8].selected) return;
  
      this.loadingMediators = true;
      let params: IParamsCollection = {
        include: ['mediator', 'mediator.address'],
        //page: { number: this.lastGridCaseMediators.first + 1, size: this.lastGridCaseMediators.rows },
      }
      if (this.lastGridCaseMediators && typeof this.lastGridCaseMediators.sortField != "undefined") params.sort = [(this.lastGridCaseMediators.sortOrder > 0 ? "-" : "") + this.lastGridCaseMediators.sortField];
  
      let filters: any = {
        caseId: new Filter(FilterOperation.equals, "caseId", "", this.case.id),
      };
      params.filter = FilterBuilder.fromObject(filters).build();
  
      let response = await firstValueFrom(this.casesMediatorsService.all(params));
      this.caseMediators = response.data;
      this.totalMediatorsRecords = response.meta['total'];
      this.loadingMediators = false;
      this.countMediators = this.totalMediatorsRecords;
      this.caseMediatorsHeader = response.data.filter(m => m.isActive);
    }

    editCaseMediator(){
      let ref = this.dialogService.open(CaseMediatorComponent, {
        closable: true,
        header: 'Añadir mediador',
        width: '50%',
        draggable: true,
        modal: false,
        data: {
          existentCaseExperts: this.caseExperts,
          caseId: this.case.id
        }
      });
  
      ref.onClose.subscribe((data: any) => {
        if (data) {
          let caseMediator = new CaseMediator();
          caseMediator.caseId = this.case.id as string;
          caseMediator.mediatorId = data.id;
          this.casesMediatorsService.save(caseMediator).subscribe({
            next: (data: any) => {
              this.messageService.add({ closable: true, severity: 'success', detail: "Mediador añadido correctamente." });
              this.loadCaseMediators();
            },
            error: (error: any) => {
              this.messageService.add({ closable: true, severity: 'error', detail: error.error.title });
            }
          });
        }
      });
    }

    deleteCaseMediator(id: string){
      this.confirmationService.confirm({
          message: "¿Está seguro que desea eliminar el mediador del expediente?",
          header: "Eliminar mediador del expediente",
          acceptLabel: "Aceptar",
          rejectLabel: "Cancelar",
          acceptButtonStyleClass: "p-button-danger",
          icon: 'pi pi-exclamation-triangle',
          accept: () => {
            this.casesMediatorsService.delete(id).subscribe({
              next: (data: any) => {
                this.messageService.add({ closable: true, severity: 'success', detail: "Mediador eliminado correctamente del expediente." });
                this.loadCaseMediators();
              },
              error: (error: any) => {
                this.messageService.add({ closable: true, severity: 'error', detail: error.error.title });
              }
            });
          }
        });
    }

    editMediator(mediator: Mediator | null) {
      let ref = this.dialogService.open(MediatorsDetailComponent, {
        closable: true,
        header: 'Ficha de mediador',
        width: '80%',
        draggable: true,
        modal: false,
        data: {
          caseId: this.case.id,
          id: mediator ? mediator.id : null
        }
      });
  
      ref.onClose.subscribe((data: any) => {
        this.loadCaseMediators();
      });
    }

    async saveCaseMediator(caseMediator: CaseMediator){
      await firstValueFrom(this.casesMediatorsService.save(caseMediator));
      this.loadCaseMediators();
    }

    async loadContractOutboundPhones() {
      let filters = {
        contractId: new Filter(FilterOperation.equals, 'contractId', "", this.case?.contractId)
      };
  
      let params: IParamsCollection = {
        filter: FilterBuilder.fromObject(filters).build()
      };
  
      let response = await firstValueFrom(this.contractOutboundPhonesService.all(params));
      this.contractOutboundPhones = response.data;
    }
}
